// import { Component } from "react"
// import Kaas from "../Images/Kaas 4.png"
// import "../Styles/Landing_Page.css"
// // import Landing_Page_img from "../Images/Landing_Page_img.png";
// // import graphic_landing_page from "../Images/graphic_landing_page.png";
// import CardsCompo2 from "../Components/CardsCompo2"
// import vr from "../Images/vr.png"
// import period from "../Images/period.jpg"
// import wwd from "../Images/landing_GroupImage.jpg"
// import analytics from "../Images/analytics.jpg"
// import teacher from "../Images/teacher.jpg"
// import LogosSection from "../Components/LogosSection"
// import { Link } from "react-router-dom"
// import Footer from "../Components/Footer"
// import Swal from "sweetalert2"
// import bg from "../Images/b2efdca3-f62c-4ee8-91ea-c5710a5d4dc8.jpg"
// import axios from "axios"
// // import { useNavigate } from "react-router-dom";

// export default class Landing_Page extends Component {
//   constructor(props) {
//     super(props)
//     this.state = {
//       popular: [],
//     }
//   }

//   setPopular(data) {
//     this.setState((prevState) => ({ popular: [...data] }))
//   }

//   componentDidMount() {
//     const url = "https://kaasbackend.vetrinahealthcare.com/"

//     axios.get(`${url}lms/popular/`).then((response) => {
//       this.setPopular(response.data.popular_courses)
//       console.log(this.state)
//     })
//   }
//   render() {
//     const fireAlert = () => {
//       Swal.fire({
//         title: "Success!",
//         text: "Thank You For Subscribing!",
//         icon: "success",
//         timer: 2000,
//         timerProgressBar: true,
//         showConfirmButton: false, // Remove the "OK" button
//       })
//     }
//     return (
//       <div >
//       <div className="container" >

//           <div className="row pb-5 pt-1">
//             <div className="col-8 col-sm-8 d-flex justify-content-start">
//               <img src={Kaas} className="Kaas_logo_landing " alt="KaaS Logo" />
//             </div>
//             <div className="col-4 col-sm-4 d-flex justify-content-end">
//               <div className="d-flex gap-2 gap-md-3">
//                 {" "}
//                 {/* Reduced gap on mobile */}
//                 <Link
//                   to="/Log"
//                   role="button"
//                   className="btn btn-sign-in btn-sm btn-md-lg"
//                   style={{
//                     backgroundColor: "#B8529E",
//                     color: "white",
//                     height: "max-content",
//                     fontSize: "0.8rem",
//                     padding: "0.25rem 0.5rem",
//                     "@media (min-width: 768px)": {
//                       fontSize: "1rem",
//                       padding: "0.375rem 0.75rem",
//                     },
//                   }}
//                 >
//                   Sign In
//                 </Link>
//                 <Link
//                   to="/RegisterPage"
//                   role="button"
//                   className="btn btn-sign-up btn-sm btn-md-lg"
//                   style={{
//                     backgroundColor: "#B8529E",
//                     color: "white",
//                     height: "max-content",
//                     fontSize: "0.8rem",
//                     padding: "0.25rem 0.5rem",
//                     "@media (min-width: 768px)": {
//                       fontSize: "1rem",
//                       padding: "0.375rem 0.75rem",
//                     },
//                   }}
//                 >
//                   Sign Up
//                 </Link>
//               </div>
//             </div>
//           </div>
//           <div className="row mt-3 mt-md-5">
//             <div className="col-12 col-md-6 d-flex flex-column justify-content-center up-skill-text">
//               <div className="display-6 display-md-5 fw-bold"> Up-Skill As You Work</div>
//               <div className="d-flex justify-content-start learning">Learning Anywhere, Anytime</div>
//               <div className="email-btn">
//                 <p
//                   style={{
//                     fontSize: "14px",
//                     paddingTop: "15px",
//                     "@media (min-width: 768px)": { fontSize: "15px", paddingTop: "20px" },
//                   }}
//                 >
//                   Welcome to KaaS, a personalized learning platform designed for students and companies alike. Explore
//                   courses in cutting-edge technologies, tailor your learning journey, and empower employees with
//                   expert-led training for skill development and career growth.
//                 </p>
//               </div>
//             </div>
//             <div className="col-12 col-md-6 d-flex justify-content-center justify-content-md-end mt-3 mt-md-0">
//               <img src={bg} className="Landing_Page_img " alt="Hero Image" />
//             </div>
//           </div>

//           <div className="row">
//             <div className=" col-12  col-sm-12 d-flex justify-content-center px-0">
//               <div className="row">
//                 <div className="col col-sm-8 d-flex align-items-start px-0">
//                   <label htmlFor="exampleInputEmail" className="form-label"></label>
//                   {/* <input
//                     type="email"
//                     className="form-control form-control1"
//                     id="exampleInputEmail1"
//                     // size="40"
//                     placeholder="Email Address"
//                     aria-describedby="emailHelp"
//                   /> */}
//                 </div>

//                 {/* <div className="col col-sm-4 d-flex align-items-start px-0">
//                   <div id="emailHelp" className="form-text"></div>
//                   <button type="submit" className="btn  Landing_Get">
//                     Get Started
//                   </button>
//                 </div> */}
//               </div>
//             </div>
//           </div>
//         </div>
//         {/* <br />
//           <br/> */}
//         {/* <div className="container-fluid ">
//           <div className="row mx-5">
//             <div className="col-sm-12 d-flex justify-content-end px-3">
//               <div className="chat_icon">
//                   <HiChat className="HChat_icon" />
//                 </div>
//             </div>
//           </div>
//         </div> */}
//         {/* <div className="container-fluid px-0 ">
//           <div className="row Graphic_img_Row">
//             <div className="col-sm-12">
//               <img src={graphic_landing_page || "/placeholder.svg"} className="graphic_img" alt="" />

//             </div>
//           </div>
//         </div> */}

// <div className="landing-skill-card">
//             <div className="landing-image-container">
//               <img src={wwd} alt="Blogs" className="landing-card-image" />
//             </div>

//             <div className="wwd-container">
//               <h2 className="heading2">What We Do</h2>
//               <p className="blogcontent">
//                 KaaS is a prominent one-stop solution for all your learning
//                 needs. The courses have been designed and developed from the
//                 learner perspective. With this software, you may learn the
//                 skills you need to advance professionally and personally.More
//                 than 200 topics are available in the app. Experts from the real
//                 world will assist you in selecting the most appropriate course
//                 for your objectives. Master the skills to grow professionally
//                 and personally with this app.
//               </p>
//             </div>
//           </div>

//         <div className="container">
//           <div className="row justify-content-center justify-content-md-around pt-4 pt-md-5 g-2">
//             <div className="landing-card col-10 col-sm-6 col-md-4 col-lg-3 py-2 mb-4">
//               <div className="knowledge d-flex flex-column align-items-center p-3">
//                 <img className="landinglogo " src={analytics} alt="Analytics"></img>
//               </div>
//               <p className="logoinfo text-center">Upgrading knowledge level and skill set</p>
//               <p className="text-center logotext">
//                 You may upskill yourself and prepare for professional progress by taking advantage of the courses
//                 provided.
//               </p>
//             </div>
//             <div className="landing-card col-10 col-sm-6 col-md-4 col-lg-3 py-2 mb-4">
//               <div className="knowledge d-flex flex-column align-items-center p-3">
//                 <img className="landinglogo " src={teacher} alt="Teacher"></img>
//               </div>
//               <p className="logoinfo text-center">Industry expert instructors.</p>
//               <p className="text-center logotext">The courses are created and taught by experts in the field.</p>
//             </div>
//             <div className="landing-card col-10 col-sm-6 col-md-4 col-lg-3 py-2 mb-4">
//               <div className="knowledge d-flex flex-column align-items-center p-3">
//                 <img className="landinglogo " src={period } alt="Convenience"></img>
//               </div>
//               <p className="logoinfo text-center">Learn at your convenience</p>
//               <p className="text-center logotext">
//                 You can learn at your own speed and in the comfort of your own home.
//               </p>
//             </div>
//           </div>
//         </div>

//         <div className="container">
//           <div className="row mt-3">
//             <div className="d-flex flex-column flex-md-row justify-content-between my-3">
//               <h3 className="mb-2 mb-md-0">
//                 <b>Popular Courses</b>
//               </h3>
//               <div className="view py-1 py-md-2 px-2 px-md-4 align-self-start">
//                 <a href="/">View All</a>
//               </div>
//             </div>
//             <div className="row">
//               {this.state.popular.map((course, idx) => (
//                 <div key={idx} className="col-12 col-sm-6 col-lg-4 mb-3">
//                   <CardsCompo2
//                     imageSrc={vr}
//                     title={course.title}
//                     price={`$ ${course.price}`}
//                     description={course.description}
//                   />
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>
//         <div className="container mt-3 mb-3">
//           <div className="row ">
//             <div className="col-sm-12 mb-3 mt-5">
//               <LogosSection />
//             </div>
//           </div>
//         </div>
//         <div className="container text-center">
//           <div className="row">
//             <h2 className="numberspeak">
//               <b>Numbers Speak</b>
//             </h2>
//           </div>
//           <div className="container text-center py-3">
//             <div className="row pt-3 pt-md-5">
//               <div className="col-6 col-md-3 px-1 myvercalline d-flex align-items-center justify-content-center mb-4 mb-md-0">
//                 <ul className="each-col-element px-0">
//                   <li className="num">200+</li>
//                   <li className="num_for fw-bold">Courses</li>
//                 </ul>
//               </div>

//               <div className="col-6 col-md-3 px-1 myvercalline d-flex align-items-center justify-content-center mb-4 mb-md-0">
//                 <ul className="each-col-element px-0 align-items-center">
//                   <li className="num">200+</li>
//                   <li className="num_for fw-bold">Industry Experts</li>
//                 </ul>
//               </div>
//               <div className="col-6 col-md-3 px-1 myvercalline d-flex align-items-center justify-content-center">
//                 <ul className="each-col-element px-0">
//                   <li className="num">5000+</li>
//                   <li className="num_for fw-bold">Trained Professional</li>
//                 </ul>
//               </div>
//               <div className="col-6 col-md-3 px-1 myvercalline d-flex align-items-center justify-content-center">
//                 <ul className="each-col-element px-0">
//                   <li className="num">200+</li>
//                   <li className="num_for fw-bold">Top Ranked Programs</li>
//                 </ul>
//               </div>
//             </div>
//           </div>
//         </div>
//         <div className="container px-3 px-md-5">
//           <div className="row">
//             <div className="col-12">
//               <div className="areyouready d-flex justify-content-center text-center">
//                 <h2 className="h3 h2-md">
//                   <b>Are You Ready To Upgrade?</b>
//                 </h2>
//               </div>
//             </div>
//           </div>
//           <div className="row mb-4">
//             <div className="col-12">
//               <div className="areyouready d-flex justify-content-center text-center">
//                 <p className="px-2 px-md-0">
//                   Join The Journey Towards An Upskilled Future By Reskilling Yourself With KaaS{" "}
//                 </p>
//               </div>
//             </div>
//           </div>
//           <div className="row mb-4">
//             <div className="col-12">
//               <form>
//                 <div className="form-group d-flex justify-content-center">
//                   <input
//                     className="emailbox w-100 w-md-75 w-lg-50"
//                     type="email"
//                     placeholder="Enter Your Email Address..."
//                     required
//                   />
//                 </div>
//                 <div className="col-12 d-flex justify-content-center">
//                   <button className="Subscribe mt-3" onClick={fireAlert}>
//                     Subscribe
//                   </button>
//                 </div>
//               </form>
//             </div>
//           </div>
//         </div>
//         <Footer />
//       </div>
//     )
//   }
// }

// import { Component } from 'react'
// import Kaas from '../Images/Kaas 4.png'
// import '../Styles/Landing_Page.css'
// // import Landing_Page_img from "../Images/Landing_Page_img.png";
// // import graphic_landing_page from "../Images/graphic_landing_page.png";
// import CardsCompo2 from '../Components/CardsCompo2'
// import vr from '../Images/vr.png'
// import period from '../Images/period.jpg'
// import wwd from '../Images/landing_GroupImage.jpg'
// import analytics from '../Images/analytics.jpg'
// import teacher from '../Images/teacher.jpg'
// import LogosSection from '../Components/LogosSection'
// import { Link } from 'react-router-dom'
// import Footer from '../Components/Footer'
// import Swal from 'sweetalert2'
// import bg from '../Images/b2efdca3-f62c-4ee8-91ea-c5710a5d4dc8.jpg'
// import axios from 'axios'
// import { FaArrowUp, FaArrowRight, FaEnvelope } from 'react-icons/fa' // Import the arrow icon
// import { motion } from 'framer-motion'

// // import { useNavigate } from "react-router-dom";

// // export default class Landing_Page extends Component {
// //   constructor(props) {
// //     super(props)
// //     this.state = {
// //       popular: [],
// //     }
// //   }

// //   setPopular(data) {
// //     this.setState((prevState) => ({ popular: [...data] }))
// //   }

// //   componentDidMount() {
// //     const url = "https://kaasbackend.vetrinahealthcare.com/"

// //     axios.get(`${url}lms/popular/`).then((response) => {
// //       this.setPopular(response.data.popular_courses)
// //       console.log(this.state)
// //     })
// //   }

// export default class Landing_Page extends Component {
//   constructor(props) {
//     super(props)
//     this.state = {
//       popular: [],
//       showBackToTop: false,
//     }
//   }

//   setPopular(data) {
//     this.setState((prevState) => ({ popular: [...data] }))
//   }

//   componentDidMount() {
//     const url = 'https://kaasbackend.vetrinahealthcare.com/'

//     axios.get(`${url}lms/popular/`).then((response) => {
//       this.setPopular(response.data.popular_courses)
//     })

//     // Add scroll event listener
//     window.addEventListener('scroll', this.handleScroll)
//   }

//   componentWillUnmount() {
//     // Remove scroll event listener
//     window.removeEventListener('scroll', this.handleScroll)
//   }

//   handleScroll = () => {
//     if (window.pageYOffset > 300) {
//       this.setState({ showBackToTop: true })
//     } else {
//       this.setState({ showBackToTop: false })
//     }
//   }

//   goToTop = () => {
//     window.scrollTo({
//       top: 0,
//       behavior: 'smooth',
//     })
//   }

//   fireAlert = () => {
//     Swal.fire({
//       title: 'Success!',
//       text: 'Thank You For Subscribing!',
//       icon: 'success',
//       timer: 2000,
//       timerProgressBar: true,
//       showConfirmButton: false,
//     })
//   }

//   handleEmailChange = (e) => {
//     this.setState({ email: e.target.value })
//   }

//   handleSubscribe = (e) => {
//     e.preventDefault()
//     if (this.state.email) {
//       Swal.fire({
//         title: 'Success!',
//         text: 'Thank You For Subscribing!',
//         icon: 'success',
//         timer: 2000,
//         timerProgressBar: true,
//         showConfirmButton: false,
//       })
//       this.setState({ email: '' })
//     } else {
//       Swal.fire({
//         title: 'Error!',
//         text: 'Please enter your email address',
//         icon: 'error',
//         timer: 2000,
//       })
//     }
//   }

//   render() {
//     const fireAlert = () => {
//       Swal.fire({
//         title: 'Success!',
//         text: 'Thank You For Subscribing!',
//         icon: 'success',
//         timer: 2000,
//         timerProgressBar: true,
//         showConfirmButton: false, // Remove the "OK" button
//       })
//     }
//     const styles = {
//       container: {
//         fontFamily: "'Poppins', sans-serif",
//         color: '#333',
//         overflowX: 'hidden',
//       },
//       header: {
//         padding: '20px 0',
//         position: 'sticky',
//         top: 0,
//         backgroundColor: 'rgba(255, 255, 255, 0.95)',
//         boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
//         zIndex: 1000,
//         transition: 'all 0.3s ease',
//       },
//       logo: {
//         height: '50px',
//         transition: 'transform 0.3s ease',
//       },
//       navButton: {
//         backgroundColor: '#B8529E',
//         color: 'white',
//         border: 'none',
//         borderRadius: '30px',
//         padding: '10px 20px',
//         fontWeight: '600',
//         transition: 'all 0.3s ease',
//         cursor: 'pointer',
//         boxShadow: '0 4px 6px rgba(184, 82, 158, 0.2)',
//         margin: '0 5px',
//       },
//       navButtonHover: {
//         transform: 'translateY(-3px)',
//         boxShadow: '0 6px 12px rgba(184, 82, 158, 0.3)',
//         background: 'linear-gradient(90deg, #B8529E 0%, #7D52A0 100%)',
//       },
//       heroSection: {
//         padding: '60px 0 40px',
//         position: 'relative',
//         overflow: 'hidden',
//       },
//       heroContent: {
//         position: 'relative',
//         zIndex: 2,
//       },
//       heroTitle: {
//         fontSize: '3.5rem',
//         fontWeight: '700',
//         marginBottom: '20px',
//         background: 'linear-gradient(90deg, #3953A3 0%, #B8529E 100%)',
//         WebkitBackgroundClip: 'text',
//         WebkitTextFillColor: 'transparent',
//         lineHeight: 1.2,
//       },
//       heroSubtitle: {
//         fontSize: '1.5rem',
//         fontWeight: '500',
//         marginBottom: '30px',
//         color: '#666',
//       },
//       heroDescription: {
//         fontSize: '1.1rem',
//         lineHeight: '1.6',
//         color: '#666',
//         marginBottom: '30px',
//         maxWidth: '600px',
//       },
//       heroImage: {
//         width: '100%',
//         maxWidth: '550px',
//         height: 'auto',
//         borderRadius: '20px',
//         boxShadow: '0 20px 40px rgba(0, 0, 0, 0.2)',
//         transition: 'transform 0.5s ease',
//       },
//       whatWeDoSection: {
//         background:
//           'linear-gradient(90deg, #3953A3 3.63%, #7D52A0 53.24%, #8852A0 61.55%, #B8529E 100%)',
//         borderRadius: '20px',
//         padding: '40px',
//         margin: '60px 0',
//         color: 'white',
//         display: 'flex',
//         flexWrap: 'wrap',
//         alignItems: 'center',
//         justifyContent: 'space-between',
//         boxShadow: '0 15px 30px rgba(0, 0, 0, 0.1)',
//       },
//       whatWeDoImage: {
//         width: '280px',
//         height: '280px',
//         objectFit: 'cover',
//         borderRadius: '50%',
//         border: '15px solid white',
//         boxShadow: '0 10px 20px rgba(0, 0, 0, 0.2)',
//       },
//       whatWeDoContent: {
//         flex: '1',
//         minWidth: '300px',
//         padding: '0 20px',
//       },
//       whatWeDoTitle: {
//         fontSize: '2.5rem',
//         fontWeight: '700',
//         marginBottom: '20px',
//       },
//       whatWeDoText: {
//         fontSize: '1.1rem',
//         lineHeight: '1.8',
//       },
//       featureCard: {
//         background: 'white',
//         borderRadius: '15px',
//         padding: '30px',
//         height: '100%',
//         transition: 'all 0.3s ease',
//         boxShadow: '0 10px 20px rgba(0, 0, 0, 0.05)',
//         display: 'flex',
//         flexDirection: 'column',
//         alignItems: 'center',
//         textAlign: 'center',
//       },
//       featureCardHover: {
//         transform: 'translateY(-10px)',
//         boxShadow: '0 15px 30px rgba(0, 0, 0, 0.1)',
//       },
//       featureIcon: {
//         fontSize: '3rem',
//         color: '#B8529E',
//         marginBottom: '20px',
//         padding: '20px',
//         borderRadius: '50%',
//         background: 'rgba(184, 82, 158, 0.1)',
//       },
//       featureTitle: {
//         fontSize: '1.5rem',
//         fontWeight: '600',
//         marginBottom: '15px',
//         color: '#333',
//       },
//       featureText: {
//         fontSize: '1rem',
//         lineHeight: '1.6',
//         color: '#666',
//       },
//       sectionTitle: {
//         fontSize: '2.5rem',
//         fontWeight: '700',
//         marginBottom: '40px',
//         textAlign: 'center',
//         position: 'relative',
//         paddingBottom: '15px',
//       },
//       sectionTitleAfter: {
//         content: "''",
//         position: 'absolute',
//         bottom: 0,
//         left: '50%',
//         transform: 'translateX(-50%)',
//         width: '80px',
//         height: '4px',
//         background: 'linear-gradient(90deg, #3953A3 0%, #B8529E 100%)',
//         borderRadius: '2px',
//       },
//       courseCard: {
//         background: 'white',
//         borderRadius: '15px',
//         overflow: 'hidden',
//         boxShadow: '0 10px 20px rgba(0, 0, 0, 0.05)',
//         transition: 'all 0.3s ease',
//         height: '100%',
//         display: 'flex',
//         flexDirection: 'column',
//       },
//       courseCardHover: {
//         transform: 'translateY(-10px)',
//         boxShadow: '0 15px 30px rgba(0, 0, 0, 0.1)',
//       },
//       courseImage: {
//         width: '100%',
//         height: '200px',
//         objectFit: 'cover',
//       },
//       courseContent: {
//         padding: '20px',
//         flex: 1,
//         display: 'flex',
//         flexDirection: 'column',
//       },
//       courseTitle: {
//         fontSize: '1.3rem',
//         fontWeight: '600',
//         marginBottom: '10px',
//         color: '#333',
//       },
//       coursePrice: {
//         fontSize: '1.2rem',
//         fontWeight: '700',
//         color: '#B8529E',
//         marginBottom: '10px',
//       },
//       courseDescription: {
//         fontSize: '0.9rem',
//         lineHeight: '1.6',
//         color: '#666',
//         flex: 1,
//       },
//       courseButton: {
//         backgroundColor: '#f5f5f5',
//         color: '#B8529E',
//         border: 'none',
//         borderRadius: '30px',
//         padding: '10px 20px',
//         fontWeight: '600',
//         transition: 'all 0.3s ease',
//         cursor: 'pointer',
//         marginTop: '15px',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//       },
//       courseButtonHover: {
//         background: 'linear-gradient(90deg, #3953A3 0%, #B8529E 100%)',
//         color: 'white',
//       },
//       partnersSection: {
//         padding: '60px 0',
//         background: '#f9f9f9',
//         borderRadius: '20px',
//         margin: '60px 0',
//       },
//       partnerLogo: {
//         height: '60px',
//         opacity: 0.7,
//         transition: 'all 0.3s ease',
//         filter: 'grayscale(100%)',
//       },
//       partnerLogoHover: {
//         opacity: 1,
//         filter: 'grayscale(0%)',
//         transform: 'scale(1.1)',
//       },
//       statsSection: {
//         padding: '60px 0',
//         textAlign: 'center',
//       },
//       statCard: {
//         padding: '30px',
//         borderRadius: '15px',
//         background: 'white',
//         boxShadow: '0 10px 20px rgba(0, 0, 0, 0.05)',
//         height: '100%',
//         transition: 'all 0.3s ease',
//       },
//       statCardHover: {
//         transform: 'translateY(-10px)',
//         boxShadow: '0 15px 30px rgba(0, 0, 0, 0.1)',
//       },
//       statNumber: {
//         fontSize: '3rem',
//         fontWeight: '700',
//         marginBottom: '10px',
//         background: 'linear-gradient(90deg, #3953A3 0%, #B8529E 100%)',
//         WebkitBackgroundClip: 'text',
//         WebkitTextFillColor: 'transparent',
//       },
//       statTitle: {
//         fontSize: '1.2rem',
//         fontWeight: '600',
//         color: '#666',
//       },
//       ctaSection: {
//         padding: '80px 0',
//         textAlign: 'center',
//         background: 'linear-gradient(135deg, #f5f7fa 0%, #e4e8eb 100%)',
//         borderRadius: '20px',
//         margin: '60px 0',
//       },
//       ctaTitle: {
//         fontSize: '2.5rem',
//         fontWeight: '700',
//         marginBottom: '20px',
//         color: '#333',
//       },
//       ctaText: {
//         fontSize: '1.2rem',
//         lineHeight: '1.6',
//         color: '#666',
//         marginBottom: '40px',
//         maxWidth: '700px',
//         margin: '0 auto 40px',
//       },
//       ctaForm: {
//         maxWidth: '500px',
//         margin: '0 auto',
//       },
//       ctaInput: {
//         width: '100%',
//         padding: '15px 20px',
//         borderRadius: '30px',
//         border: '1px solid #ddd',
//         fontSize: '1rem',
//         marginBottom: '20px',
//         outline: 'none',
//         transition: 'all 0.3s ease',
//       },
//       ctaInputFocus: {
//         borderColor: '#B8529E',
//         boxShadow: '0 0 0 3px rgba(184, 82, 158, 0.2)',
//       },
//       ctaButton: {
//         backgroundColor: '#B8529E',
//         color: 'white',
//         border: 'none',
//         borderRadius: '30px',
//         padding: '15px 30px',
//         fontSize: '1.1rem',
//         fontWeight: '600',
//         transition: 'all 0.3s ease',
//         cursor: 'pointer',
//         boxShadow: '0 10px 20px rgba(184, 82, 158, 0.3)',
//         display: 'inline-flex',
//         alignItems: 'center',
//       },
//       ctaButtonHover: {
//         background: 'linear-gradient(90deg, #B8529E 0%, #7D52A0 100%)',
//         transform: 'translateY(-3px)',
//         boxShadow: '0 15px 30px rgba(184, 82, 158, 0.4)',
//       },
//       footer: {
//         backgroundColor: '#222',
//         color: 'white',
//         padding: '60px 0 30px',
//       },
//       footerLogo: {
//         height: '40px',
//         marginBottom: '20px',
//       },
//       footerText: {
//         fontSize: '0.9rem',
//         lineHeight: '1.6',
//         color: '#aaa',
//         marginBottom: '20px',
//       },
//       footerTitle: {
//         fontSize: '1.2rem',
//         fontWeight: '600',
//         marginBottom: '20px',
//         color: 'white',
//       },
//       footerLink: {
//         color: '#aaa',
//         textDecoration: 'none',
//         display: 'block',
//         marginBottom: '10px',
//         transition: 'all 0.3s ease',
//       },
//       footerLinkHover: {
//         color: '#B8529E',
//         transform: 'translateX(5px)',
//       },
//       socialIcon: {
//         color: 'white',
//         fontSize: '1.5rem',
//         marginRight: '15px',
//         transition: 'all 0.3s ease',
//       },
//       socialIconHover: {
//         color: '#B8529E',
//         transform: 'translateY(-3px)',
//       },
//       copyright: {
//         borderTop: '1px solid #444',
//         marginTop: '30px',
//         paddingTop: '20px',
//         fontSize: '0.9rem',
//         color: '#aaa',
//         textAlign: 'center',
//       },
//       // Animation classes
//       animateOnScroll: {
//         opacity: 0,
//         transform: 'translateY(30px)',
//         transition: 'opacity 0.8s ease, transform 0.8s ease',
//       },
//       animated: {
//         opacity: 1,
//         transform: 'translateY(0)',
//       },
//       // Responsive styles
//       responsive: {
//         heroTitle: {
//           fontSize: '2.5rem',
//         },
//         heroSubtitle: {
//           fontSize: '1.2rem',
//         },
//         sectionTitle: {
//           fontSize: '2rem',
//         },
//         whatWeDoTitle: {
//           fontSize: '2rem',
//         },
//         ctaTitle: {
//           fontSize: '2rem',
//         },
//       },
//     }
//     return (
//       <div>
//         <div className='container' style={{ position: 'relative' }}>
//           <div
//             className='row pt-3'
//             style={{
//               position: 'sticky',
//               top: 0,
//               zIndex: 1000,
//               backgroundColor: 'white', // Add background color so content scrolls underneath
//               paddingBottom: '0.5rem', // Reduced bottom padding
//               paddingTop: '0.5rem', // Reduced top padding to match
//             }}
//           >
//             {' '}
//             {/* Added pt-3 for top margin */}
//             <div className='col-8 col-sm-8 d-flex justify-content-start'>
//               <img src={Kaas} className='Kaas_logo_landing ' alt='KaaS Logo' />
//             </div>
//             <div className='col-4 col-sm-4 d-flex justify-content-end'>
//               <div className='d-flex gap-2 gap-md-3'>
//                 {' '}
//                 {/* Reduced gap on mobile */}
//                 {/* <Link
//                   to='/Log'
//                   role='button'
//                   className='btn btn-sign-in btn-md' // Changed from btn-sm to btn-md
//                   style={{
//                     backgroundColor: '#B8529E',
//                     color: 'white',
//                     borderRadius: '20px',
//                     fontWeight: '600',
//                     padding: '8px 20px',
//                     border: 'none',
//                     boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
//                     transition: 'all 0.3s ease',
//                     '&:hover': {
//                       backgroundColor: '#9C3D82',
//                       transform: 'translateY(-2px)',
//                       boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
//                     },
//                   }}
//                 >
//                   Sign In
//                 </Link> */}
//                 <Link
//   to="/Log"
//   role="button"
//   className="btn btn-sign-in btn-md"
//   style={{
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     backgroundColor: '#B8529E',
//     color: 'white',
//     borderRadius: '20px',
//     fontWeight: 600,
//     padding: '8px 20px',
//     border: 'none',
//     boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
//     textDecoration: 'none',
//   }}
//   onMouseEnter={(e) => {
//     e.target.style.backgroundColor = '#9C3D82';
//     e.target.style.transform = 'translateY(-2px)';
//     e.target.style.boxShadow = '0 4px 8px rgba(0,0,0,0.2)';
//   }}
//   onMouseLeave={(e) => {
//     e.target.style.backgroundColor = '#B8529E';
//     e.target.style.transform = 'translateY(0)';
//     e.target.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
//   }}
// >
//   Sign In
// </Link>

//                 {/* <Link
//                   to='/RegisterPage'
//                   role='button'
//                   className='btn btn-sign-up btn-md' // Changed from btn-sm to btn-md
//                   style={{
//                     backgroundColor: '#B8529E',
//                     color: 'white',
//                     borderRadius: '20px',
//                     fontWeight: '600',
//                     padding: '8px 20px',
//                     border: 'none',
//                     boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
//                     transition: 'all 0.3s ease',
//                     '&:hover': {
//                       backgroundColor: '#9C3D82',
//                       transform: 'translateY(-2px)',
//                       boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
//                     },
//                   }}
//                 >
//                   Sign Up
//                 </Link> */}
//                 <Link
//   to="/RegisterPage"
//   role="button"
//   className="btn btn-sign-up btn-md"
//   style={{
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     backgroundColor: '#B8529E',
//     color: 'white',
//     borderRadius: '20px',
//     fontWeight: 600,
//     padding: '8px 20px',
//     border: 'none',
//     boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
//     textDecoration: 'none',
//   }}
//   onMouseEnter={(e) => {
//     e.target.style.backgroundColor = '#9C3D82';
//     e.target.style.transform = 'translateY(-2px)';
//     e.target.style.boxShadow = '0 4px 8px rgba(0,0,0,0.2)';
//   }}
//   onMouseLeave={(e) => {
//     e.target.style.backgroundColor = '#B8529E';
//     e.target.style.transform = 'translateY(0)';
//     e.target.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
//   }}
// >
//   Sign Up
// </Link>

//               </div>
//             </div>
//           </div>
//           {/* <div className="row mt-3 mt-md-5">
//             <div className="col-12 col-md-6 d-flex flex-column justify-content-center up-skill-text">
//               <div className="display-6 display-md-5 fw-bold"> Up-Skill As You Work</div>
//               <div className="d-flex justify-content-start learning">Learning Anywhere, Anytime</div>
//               <div className="email-btn">
//                 <p
//                   style={{
//                     fontSize: "14px",
//                     paddingTop: "15px",
//                     "@media (min-width: 768px)": { fontSize: "15px", paddingTop: "20px" },
//                   }}
//                 >
//                   Welcome to KaaS, a personalized learning platform designed for students and companies alike. Explore
//                   courses in cutting-edge technologies, tailor your learning journey, and empower employees with
//                   expert-led training for skill development and career growth.
//                 </p>
//               </div>
//             </div>
//             <div className="col-12 col-md-6 d-flex justify-content-center justify-content-md-end mt-3 mt-md-0">
//               <img src={bg} className="Landing_Page_img " alt="Hero Image" />
//             </div>
//           </div> */}
//           <div style={{ }}>
//             <section style={styles.heroSection}>
//               <div className='container'>
//                 <div className='row align-items-center'>
//                   <div className='col-12 col-lg-6' style={styles.heroContent}>
//                     <motion.h1
//                       style={styles.heroTitle}
//                       initial={{ opacity: 0, y: 30 }}
//                       animate={{ opacity: 1, y: 0 }}
//                       transition={{ duration: 0.8 }}
//                     >
//                       Up-Skill As You Work
//                     </motion.h1>
//                     <motion.h2
//                       style={styles.heroSubtitle}
//                       initial={{ opacity: 0, y: 30 }}
//                       animate={{ opacity: 1, y: 0 }}
//                       transition={{ duration: 0.8, delay: 0.2 }}
//                     >
//                       Learning Anywhere, Anytime
//                     </motion.h2>
//                     <motion.p
//                       style={styles.heroDescription}
//                       initial={{ opacity: 0, y: 30 }}
//                       animate={{ opacity: 1, y: 0 }}
//                       transition={{ duration: 0.8, delay: 0.4 }}
//                     >
//                       Welcome to KaaS, a personalized learning platform designed
//                       for students and companies alike. Explore courses in
//                       cutting-edge technologies, tailor your learning journey,
//                       and empower employees with expert-led training for skill
//                       development and career growth.
//                     </motion.p>
//                     {/* <motion.div
//                       initial={{ opacity: 0, y: 30 }}
//                       animate={{ opacity: 1, y: 0 }}
//                       transition={{ duration: 0.8, delay: 0.6 }}
//                     >
//                       <Link
//                         to='/'
//                         style={{
//                           ...styles.navButton,
//                           padding: '12px 30px',
//                           fontSize: '1.1rem',
//                           display: 'inline-flex',
//                           alignItems: 'center',
//                           gap: '10px',
//                         }}
//                         onMouseOver={(e) => {
//                           Object.assign(e.target.style, styles.navButtonHover)
//                         }}
//                         onMouseOut={(e) => {
//                           e.target.style.transform = ''
//                           e.target.style.boxShadow = styles.navButton.boxShadow
//                           e.target.style.background =
//                             styles.navButton.backgroundColor
//                         }}
//                       >
//                         Explore Courses <FaArrowRight />
//                       </Link>
//                     </motion.div> */}
//                   </div>
//                   <div className='col-12 col-lg-6 mt-5 mt-lg-0 text-center'>
//                     <motion.img
//                       src={bg}
//                       alt='Hero'
//                       style={styles.heroImage}
//                       initial={{ opacity: 0, scale: 0.8 }}
//                       animate={{ opacity: 1, scale: 1 }}
//                       transition={{ duration: 0.8, delay: 0.4 }}
//                       whileHover={{
//                         rotate: 2,
//                         scale: 1.05,
//                         transition: { duration: 0.3 },
//                       }}
//                     />
//                   </div>
//                 </div>
//               </div>
//             </section>

//             <div className='row'>
//               <div className=' col-12  col-sm-12 d-flex justify-content-center px-0'>
//                 <div className='row'>
//                   <div className='col col-sm-8 d-flex align-items-start px-0'>
//                     <label
//                       htmlFor='exampleInputEmail'
//                       className='form-label'
//                     ></label>
//                     {/* <input
//                     type="email"
//                     className="form-control form-control1"
//                     id="exampleInputEmail1"
//                     // size="40"
//                     placeholder="Email Address"
//                     aria-describedby="emailHelp"
//                   /> */}
//                   </div>

//                   {/* <div className="col col-sm-4 d-flex align-items-start px-0">
//                   <div id="emailHelp" className="form-text"></div>
//                   <button type="submit" className="btn  Landing_Get">
//                     Get Started
//                   </button>
//                 </div> */}
//                 </div>
//               </div>
//             </div>
//           </div>
//           {/* <br />
//           <br/> */}
//           {/* <div className="container-fluid ">
//           <div className="row mx-5">
//             <div className="col-sm-12 d-flex justify-content-end px-3">
//               <div className="chat_icon">
//                   <HiChat className="HChat_icon" />
//                 </div>
//             </div>
//           </div>
//         </div> */}
//           {/* <div className="container-fluid px-0 ">
//           <div className="row Graphic_img_Row">
//             <div className="col-sm-12">
//               <img src={graphic_landing_page || "/placeholder.svg"} className="graphic_img" alt="" />

//             </div>
//           </div>
//         </div> */}

//           {/* <div className="landing-skill-card">
//           <div className="landing-image-container">
//             <img src={wwd} alt="Blogs" className="landing-card-image" />
//           </div>

//           <div className="wwd-container">
//             <h2 className="heading2">What We Do</h2>
//             <p className="blogcontent">
//               KaaS is a prominent one-stop solution for all your learning
//               needs. The courses have been designed and developed from the
//               learner perspective. With this software, you may learn the
//               skills you need to advance professionally and personally.More
//               than 200 topics are available in the app. Experts from the real
//               world will assist you in selecting the most appropriate course
//               for your objectives. Master the skills to grow professionally
//               and personally with this app.
//             </p>
//           </div>
//         </div> */}

//           <section className='container animate-on-scroll'>
//             <div style={styles.whatWeDoSection}>
//               <div className='row align-items-center'>
//                 <div className='col-12 col-md-4 text-center mb-4 mb-md-0'>
//                   <img
//                     src={wwd}
//                     alt='What We Do'
//                     style={styles.whatWeDoImage}
//                     className='animate-on-scroll'
//                   />
//                 </div>
//                 <div className='col-12 col-md-8' style={styles.whatWeDoContent}>
//                   <h2
//                     style={styles.whatWeDoTitle}
//                     className='animate-on-scroll'
//                   >
//                     What We Do
//                   </h2>
//                   <p style={styles.whatWeDoText} className='animate-on-scroll'>
//                     KaaS is a prominent one-stop solution for all your learning
//                     needs. The courses have been designed and developed from the
//                     learner perspective. With this software, you may learn the
//                     skills you need to advance professionally and personally.
//                     More than 200 topics are available in the app. Experts from
//                     the real world will assist you in selecting the most
//                     appropriate course for your objectives. Master the skills to
//                     grow professionally and personally with this app.
//                   </p>
//                 </div>
//               </div>
//             </div>
//           </section>

//           <div className='container'>
//             <div className='row justify-content-center justify-content-md-around pt-4 pt-md-5 g-2'>
//               <div className='landing-card col-10 col-sm-6 col-md-4 col-lg-3 py-2 mb-4'>
//                 <div className='knowledge d-flex flex-column align-items-center p-3'>
//                   <img
//                     className='landinglogo '
//                     src={analytics}
//                     alt='Analytics'
//                   ></img>
//                 </div>
//                 <p className='logoinfo text-center'>
//                   Upgrading knowledge level and skill set
//                 </p>
//                 <p className='text-center logotext'>
//                   You may upskill yourself and prepare for professional progress
//                   by taking advantage of the courses provided.
//                 </p>
//               </div>
//               <div className='landing-card col-10 col-sm-6 col-md-4 col-lg-3 py-2 mb-4'>
//                 <div className='knowledge d-flex flex-column align-items-center p-3'>
//                   <img
//                     className='landinglogo '
//                     src={teacher}
//                     alt='Teacher'
//                   ></img>
//                 </div>
//                 <p className='logoinfo text-center'>
//                   Industry expert instructors.
//                 </p>
//                 <p className='text-center logotext'>
//                   The courses are created and taught by experts in the field.
//                 </p>
//               </div>
//               <div className='landing-card col-10 col-sm-6 col-md-4 col-lg-3 py-2 mb-4'>
//                 <div className='knowledge d-flex flex-column align-items-center p-3'>
//                   <img
//                     className='landinglogo '
//                     src={period}
//                     alt='Convenience'
//                   ></img>
//                 </div>
//                 <p className='logoinfo text-center'>
//                   Learn at your convenience
//                 </p>
//                 <p className='text-center logotext'>
//                   You can learn at your own speed and in the comfort of your own
//                   home.
//                 </p>
//               </div>
//             </div>
//           </div>

//           <div className='container'>
//             <div className='row mt-3'>
//               <div className='d-flex flex-column flex-md-row justify-content-between my-3'>
//                 <h3 className='mb-2 mb-md-0'>
//                   <b>Popular Courses</b>
//                 </h3>
//                 <div className='view py-1 py-md-2 px-2 px-md-4 align-self-start'>
//                   <a href='/'>View All</a>
//                 </div>
//               </div>
//               <div className='row'>
//                 {this.state.popular.map((course, idx) => (
//                   <div key={idx} className='col-12 col-sm-6 col-lg-4 mb-3'>
//                     <CardsCompo2
//                       imageSrc={vr}
//                       title={course.title}
//                       // price={`$ ${course.price}`}
//                       price={`${course.price}`}

//                       description={course.description}
//                     />
//                   </div>
//                 ))}
//               </div>
//             </div>
//           </div>
//           <div className='container mt-3 mb-3'>
//             <div className='row '>
//               <div className='col-sm-12 mb-3 mt-5'>
//                 <LogosSection />
//               </div>
//             </div>
//           </div>
//           {/* <div className="container text-center">
//           <div className="row">
//             <h2 className="numberspeak">
//               <b>Numbers Speak</b>
//             </h2>
//           </div>
//           <div className="container text-center py-3">
//             <div className="row pt-3 pt-md-5">
//               <div className="col-6 col-md-3 px-1 myvercalline d-flex align-items-center justify-content-center mb-4 mb-md-0">
//                 <ul className="each-col-element px-0">
//                   <li className="num">200+</li>
//                   <li className="num_for fw-bold">Courses</li>
//                 </ul>
//               </div>

//               <div className="col-6 col-md-3 px-1 myvercalline d-flex align-items-center justify-content-center mb-4 mb-md-0">
//                 <ul className="each-col-element px-0 align-items-center">
//                   <li className="num">200+</li>
//                   <li className="num_for fw-bold">Industry Experts</li>
//                 </ul>
//               </div>
//               <div className="col-6 col-md-3 px-1 myvercalline d-flex align-items-center justify-content-center">
//                 <ul className="each-col-element px-0">
//                   <li className="num">5000+</li>
//                   <li className="num_for fw-bold">Trained Professional</li>
//                 </ul>
//               </div>
//               <div className="col-6 col-md-3 px-1 myvercalline d-flex align-items-center justify-content-center">
//                 <ul className="each-col-element px-0">
//                   <li className="num">200+</li>
//                   <li className="num_for fw-bold">Top Ranked Programs</li>
//                 </ul>
//               </div>
//             </div>
//           </div>
//         </div> */}
//           <section style={styles.statsSection}>
//             <div className='container'>
//               <h2 style={styles.sectionTitle} className='animate-on-scroll'>
//                 Numbers Speak
//                 <span style={styles.sectionTitleAfter}></span>
//               </h2>
//               <div className='row'>
//                 <div className='col-6 col-md-3 mb-4'>
//                   <motion.div
//                     style={styles.statCard}
//                     className='animate-on-scroll'
//                     whileHover={{
//                       y: -10,
//                       boxShadow: '0 15px 30px rgba(0, 0, 0, 0.1)',
//                       transition: { duration: 0.3 },
//                     }}
//                   >
//                     <motion.div
//                       initial={{ opacity: 0, scale: 0.5 }}
//                       animate={{ opacity: 1, scale: 1 }}
//                       transition={{ duration: 0.5 }}
//                     >
//                       <h3 style={styles.statNumber}>200+</h3>
//                       <p style={styles.statTitle}>Courses</p>
//                     </motion.div>
//                   </motion.div>
//                 </div>
//                 <div className='col-6 col-md-3 mb-4'>
//                   <motion.div
//                     style={styles.statCard}
//                     className='animate-on-scroll'
//                     whileHover={{
//                       y: -10,
//                       boxShadow: '0 15px 30px rgba(0, 0, 0, 0.1)',
//                       transition: { duration: 0.3 },
//                     }}
//                   >
//                     <motion.div
//                       initial={{ opacity: 0, scale: 0.5 }}
//                       animate={{ opacity: 1, scale: 1 }}
//                       transition={{ duration: 0.5, delay: 0.1 }}
//                     >
//                       <h3 style={styles.statNumber}>200+</h3>
//                       <p style={styles.statTitle}>Industry Experts</p>
//                     </motion.div>
//                   </motion.div>
//                 </div>
//                 <div className='col-6 col-md-3 mb-4'>
//                   <motion.div
//                     style={styles.statCard}
//                     className='animate-on-scroll'
//                     whileHover={{
//                       y: -10,
//                       boxShadow: '0 15px 30px rgba(0, 0, 0, 0.1)',
//                       transition: { duration: 0.3 },
//                     }}
//                   >
//                     <motion.div
//                       initial={{ opacity: 0, scale: 0.5 }}
//                       animate={{ opacity: 1, scale: 1 }}
//                       transition={{ duration: 0.5, delay: 0.2 }}
//                     >
//                       <h3 style={styles.statNumber}>5000+</h3>
//                       <p style={styles.statTitle}>Trained Professionals</p>
//                     </motion.div>
//                   </motion.div>
//                 </div>
//                 <div className='col-6 col-md-3 mb-4'>
//                   <motion.div
//                     style={styles.statCard}
//                     className='animate-on-scroll'
//                     whileHover={{
//                       y: -10,
//                       boxShadow: '0 15px 30px rgba(0, 0, 0, 0.1)',
//                       transition: { duration: 0.3 },
//                     }}
//                   >
//                     <motion.div
//                       initial={{ opacity: 0, scale: 0.5 }}
//                       animate={{ opacity: 1, scale: 1 }}
//                       transition={{ duration: 0.5, delay: 0.3 }}
//                     >
//                       <h3 style={styles.statNumber}>200+</h3>
//                       <p style={styles.statTitle}>Top Ranked Programs</p>
//                     </motion.div>
//                   </motion.div>
//                 </div>
//               </div>
//             </div>
//           </section>
//           {/* <div className="container px-3 px-md-5">
//           <div className="row">
//             <div className="col-12">
//               <div className="areyouready d-flex justify-content-center text-center">
//                 <h2 className="h3 h2-md">
//                   <b>Are You Ready To Upgrade?</b>
//                 </h2>
//               </div>
//             </div>
//           </div>
//           <div className="row mb-4">
//             <div className="col-12">
//               <div className="areyouready d-flex justify-content-center text-center">
//                 <p className="px-2 px-md-0">
//                   Join The Journey Towards An Upskilled Future By Reskilling Yourself With KaaS{" "}
//                 </p>
//               </div>
//             </div>
//           </div>
//           <div className="row mb-4">
//             <div className="col-12">
//               <form>
//                 <div className="form-group d-flex justify-content-center">
//                   <input
//                     className="emailbox w-100 w-md-75 w-lg-50"
//                     type="email"
//                     placeholder="Enter Your Email Address..."
//                     required
//                   />
//                 </div>
//                 <div className="col-12 d-flex justify-content-center">
//                   <button className="Subscribe mt-3" onClick={fireAlert}>
//                     Subscribe
//                   </button>
//                 </div>
//               </form>
//             </div>
//           </div>
//         </div> */}
//           <section style={styles.ctaSection} className='animate-on-scroll'>
//             <div className='container'>
//               <h2 style={styles.ctaTitle}>Are You Ready To Upgrade?</h2>
//               <p style={styles.ctaText}>
//                 Join The Journey Towards An Upskilled Future By Reskilling
//                 Yourself With KaaS
//               </p>
//               <form style={styles.ctaForm} onSubmit={this.handleSubscribe}>
//                 <div className='mb-3'>
//                   <input
//                     type='email'
//                     placeholder='Enter Your Email Address...'
//                     style={styles.ctaInput}
//                     // value={email}
//                     onChange={this.handleEmailChange}
//                     onFocus={(e) => {
//                       Object.assign(e.target.style, styles.ctaInputFocus)
//                     }}
//                     onBlur={(e) => {
//                       e.target.style.borderColor =
//                         styles.ctaInput.border.split(' ')[2]
//                       e.target.style.boxShadow = 'none'
//                     }}
//                     required
//                   />
//                 </div>
//                 <motion.button
//                   type='submit'
//                   style={styles.ctaButton}
//                   whileHover={{
//                     y: -3,
//                     boxShadow: '0 15px 30px rgba(184, 82, 158, 0.4)',
//                     background:
//                       'linear-gradient(90deg, #B8529E 0%, #7D52A0 100%)',
//                   }}
//                   whileTap={{ scale: 0.95 }}
//                 >
//                   Subscribe <FaEnvelope style={{ marginLeft: '10px' }} />
//                 </motion.button>
//               </form>
//             </div>
//           </section>

//           {this.state.showBackToTop && (
//             <button
//               type='button'
//               className='back-to-top-btn'
//               onClick={this.goToTop}
//             >
//               <FaArrowUp />
//             </button>
//           )}
//           <Footer />
//         </div>
//       </div>
//     )
//   }
// }

// import { Component } from 'react'
// import Kaas from '../Images/Kaas 4.png'
// // import '../Styles/Landing_Page.css' // Styles will be handled inline or in the styles object
// // import Landing_Page_img from "../Images/Landing_Page_img.png";
// // import graphic_landing_page from "../Images/graphic_landing_page.png";
// import CardsCompo2 from '../Components/CardsCompo2'
// import vr from '../Images/vr.png' // Assuming this is a generic course image placeholder
// import period from '../Images/period.jpg'
// import wwd from '../Images/landing_GroupImage.jpg'
// import analytics from '../Images/analytics.jpg'
// import teacher from '../Images/teacher.jpg'
// import LogosSection from '../Components/LogosSection'
// import { Link } from 'react-router-dom'
// import Footer from '../Components/Footer'
// import Swal from 'sweetalert2'
// import bg from '../Images/b2efdca3-f62c-4ee8-91ea-c5710a5d4dc8.jpg' // Hero image
// import axios from 'axios'
// import { FaArrowUp, FaArrowRight, FaEnvelope } from 'react-icons/fa'
// import { motion } from 'framer-motion'

// // Define Vetrina Colors
// const VETRINA_PURPLE = '#B8529E';
// const VETRINA_ORANGE = '#FF6600';
// const VETRINA_DARK_PURPLE_ACCENT = '#7D52A0'; // For gradients
// const VETRINA_TEXT_PRIMARY = '#333';
// const VETRINA_TEXT_SECONDARY = '#666';
// const VETRINA_BACKGROUND_LIGHT = '#f9f9f9';
// const VETRINA_FOOTER_BG = '#222'; // Keeping existing footer dark bg

// export default class Landing_Page extends Component {
//   constructor(props) {
//     super(props)
//     this.state = {
//       popular: [],
//       showBackToTop: false,
//       email: '',
//       // States for hover effects
//       hoveredFeatureCard: null, // index or id
//       hoveredCourseCard: null,  // index or id
//       hoveredStatCard: null,    // index or id
//       // Add more hover states if needed for other elements
//     }
//   }

//   setPopular(data) {
//     this.setState((prevState) => ({ popular: [...data] }))
//   }

//   componentDidMount() {
//     const url = 'https://kaasbackend.vetrinahealthcare.com/'
//     axios.get(`${url}lms/popular/`).then((response) => {
//       this.setPopular(response.data.popular_courses)
//     })
//     window.addEventListener('scroll', this.handleScroll)
//   }

//   componentWillUnmount() {
//     window.removeEventListener('scroll', this.handleScroll)
//   }

//   handleScroll = () => {
//     if (window.pageYOffset > 300) {
//       this.setState({ showBackToTop: true })
//     } else {
//       this.setState({ showBackToTop: false })
//     }
//   }

//   goToTop = () => {
//     window.scrollTo({
//       top: 0,
//       behavior: 'smooth',
//     })
//   }

//   handleEmailChange = (e) => {
//     this.setState({ email: e.target.value })
//   }

//   handleSubscribe = (e) => {
//     e.preventDefault()
//     if (this.state.email) {
//       Swal.fire({
//         title: 'Success!',
//         text: 'Thank You For Subscribing!',
//         icon: 'success',
//         timer: 2000,
//         timerProgressBar: true,
//         showConfirmButton: false,
//       })
//       this.setState({ email: '' })
//     } else {
//       Swal.fire({
//         title: 'Error!',
//         text: 'Please enter your email address',
//         icon: 'error',
//         timer: 2000,
//         showConfirmButton: false,
//       })
//     }
//   }

//   // Hover handlers
//   setHoveredFeatureCard = (index) => this.setState({ hoveredFeatureCard: index });
//   setHoveredCourseCard = (index) => this.setState({ hoveredCourseCard: index });
//   setHoveredStatCard = (index) => this.setState({ hoveredStatCard: index });

//   render() {
//     const { hoveredFeatureCard, hoveredCourseCard, hoveredStatCard } = this.state;

//     // Styles object - incorporating Vetrina theme
//     const styles = {
//       // General
//       container: {
//         fontFamily: "'Poppins', sans-serif", // Make sure Poppins is imported in your main HTML or CSS
//         color: VETRINA_TEXT_PRIMARY,
//         overflowX: 'hidden',
//       },
//       // Header
//       header: { // Applied to the sticky row
//         padding: '0.5rem 0', // Reduced padding
//         position: 'sticky',
//         top: 0,
//         backgroundColor: 'rgba(255, 255, 255, 0.98)', // Slightly more opaque
//         boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
//         zIndex: 1000,
//         transition: 'all 0.3s ease',
//       },
//       logo: { // For Kaas Logo
//         height: '50px', // Default from .Kaas_logo_landing
//         width: '140px', // Default from .Kaas_logo_landing
//         // Media query for larger screens would typically be in CSS
//         // For inline, you might use JS to detect screen size or accept it as is.
//         // Example: window.innerWidth > 768 ? '110px' : '100px' (but this is complex for many styles)
//       },
//       navButton: { // Base style for Sign In/Up, adapted for new theme
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         backgroundColor: VETRINA_PURPLE,
//         color: 'white',
//         borderRadius: '20px',
//         fontWeight: 600,
//         padding: '8px 20px',
//         border: 'none',
//         boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
//         textDecoration: 'none',
//         transition: 'all 0.3s ease',
//         cursor: 'pointer',
//       },
//       navButtonHover: { // To be applied on hover
//         backgroundColor: VETRINA_ORANGE, // Changed hover to orange
//         transform: 'translateY(-2px)',
//         boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
//       },
//       // Hero Section
//       heroSection: {
//         padding: '60px 0 40px',
//         position: 'relative',
//         overflow: 'hidden',
//         // background: `linear-gradient(135deg, #f5f7fa 0%, #e4e8eb 100%)`, // Optional subtle background
//       },
//       heroContent: {
//         position: 'relative',
//         zIndex: 2,
//       },
//       heroTitle: {
//         fontSize: '3.5rem', // Base, consider media queries for '2.5rem'
//         fontWeight: '700',
//         marginBottom: '20px',
//         background: `linear-gradient(90deg, ${VETRINA_ORANGE} 0%, ${VETRINA_PURPLE} 100%)`,
//         WebkitBackgroundClip: 'text',
//         backgroundClip: 'text',
//         WebkitTextFillColor: 'transparent',
//         lineHeight: 1.2,
//       },
//       heroSubtitle: {
//         fontSize: '1.5rem', // Base
//         fontWeight: '500',
//         marginBottom: '30px',
//         color: VETRINA_TEXT_SECONDARY,
//       },
//       heroDescription: {
//         fontSize: '1.1rem',
//         lineHeight: '1.6',
//         color: VETRINA_TEXT_SECONDARY,
//         marginBottom: '30px',
//         maxWidth: '600px',
//       },
//       heroImage: { // Corresponds to .Landing_Page_img
//         width: '100%',
//         maxWidth: '550px', // equivalent to 35rem approx for .Landing_Page_img
//         height: 'auto', // maintain aspect ratio
//         // height: '24rem', // from .Landing_Page_img (maxWidth will likely control this better)
//         borderRadius: '20px',
//         boxShadow: '0 20px 40px rgba(0, 0, 0, 0.2)',
//         transition: 'transform 0.5s ease, box-shadow 0.5s ease',
//       },
//       // What We Do / VetLearn Section (Shared styling)
//       contentSectionGradient: {
//         background: `linear-gradient(120deg, ${VETRINA_ORANGE} 0%, ${VETRINA_PURPLE} 100%)`,
//         borderRadius: '20px',
//         padding: '40px',
//         margin: '60px 0',
//         color: 'white',
//         boxShadow: '0 15px 30px rgba(0, 0, 0, 0.1)',
//       },
//       contentSectionImage: { // For WWD image
//         width: '280px',
//         height: '280px',
//         objectFit: 'cover',
//         borderRadius: '50%',
//         border: '15px solid white',
//         boxShadow: '0 10px 20px rgba(0, 0, 0, 0.2)',
//       },
//       contentSectionBody: { // Text part
//         flex: '1',
//         minWidth: '300px',
//         padding: '0 20px',
//       },
//       contentTitle: { // For "What We Do", "Who We Are"
//         fontSize: '2.5rem', // Base
//         fontWeight: '700',
//         marginBottom: '20px',
//       },
//       contentText: {
//         fontSize: '1.1rem',
//         lineHeight: '1.8',
//         marginBottom: '15px',
//       },
//       // Feature Cards (Upgrading knowledge, etc.) - combines .landing-card and others
//       featureCard: {
//         background: 'linear-gradient(145deg, #ffffff, #f0f0f0)', // Light bg
//         borderRadius: '15px',
//         padding: '20px', // Adjusted from 1rem
//         height: '100%', // To make cards in a row equal height if needed, or set fixed height
//         // height: '24rem', // from .landing-card, if fixed height is desired
//         // width: '16rem', // from .landing-card, Bootstrap cols will handle width mostly
//         display: 'flex',
//         flexDirection: 'column',
//         alignItems: 'center',
//         textAlign: 'center',
//         transition: 'all 0.3s ease',
//         boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
//       },
//       featureCardHover: {
//         transform: 'translateY(-10px) scale(1.05)',
//         boxShadow: '0 15px 30px rgba(80, 0, 80, 0.2)', // Purple shadow
//       },
//       featureCardIconContainer: { // Corresponds to .knowledge
//         width: '100%',
//         padding: '20px 15px', // Adjusted
//         background: 'white',
//         borderRadius: '10px',
//         boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.05)',
//         marginBottom: '15px',
//         display: 'flex',
//         flexDirection: 'column',
//         alignItems: 'center',
//       },
//       featureCardIcon: { // Corresponds to .landinglogo
//         height: '5rem', // Adjusted from 6rem
//         width: 'auto',
//         objectFit: 'contain',
//         marginBottom: '15px',
//       },
//       featureCardTitle: { // Corresponds to .logoinfo
//         fontSize: '1.2rem',
//         fontWeight: 'bold',
//         color: VETRINA_PURPLE,
//         margin: '10px 0 5px',
//       },
//       featureCardText: { // Corresponds to .logotext
//         fontSize: '0.9rem',
//         lineHeight: '1.5',
//         color: VETRINA_TEXT_SECONDARY,
//         flexGrow: 1,
//       },
//       // General Section Title
//       sectionTitle: {
//         fontSize: '2.5rem', // Base
//         fontWeight: '700',
//         marginBottom: '10px', // Reduced margin before underline
//         textAlign: 'center',
//         position: 'relative', // Needed if using absolute for underline
//         color: VETRINA_TEXT_PRIMARY,
//       },
//       sectionTitleUnderline: { // Replaces sectionTitleAfter pseudo-element
//         width: '80px',
//         height: '4px',
//         background: `linear-gradient(90deg, ${VETRINA_ORANGE} 0%, ${VETRINA_PURPLE} 100%)`,
//         borderRadius: '2px',
//         margin: '0 auto 40px auto', // Center it and add bottom margin
//       },
//       // Popular Courses - CardCompo2 styling is internal to it. These are for the section.
//       popularCoursesSection: {
//         padding: '40px 0',
//       },
//       viewAllLink: { // For "View All"
//         color: VETRINA_PURPLE,
//         textDecoration: 'none',
//         fontWeight: '600',
//         padding: '8px 15px',
//         borderRadius: '20px',
//         transition: 'all 0.3s ease',
//         border: `1px solid ${VETRINA_PURPLE}`,
//       },
//       viewAllLinkHover: {
//         backgroundColor: VETRINA_PURPLE,
//         color: 'white',
//       },
//       // Partners Section (LogosSection is a component)
//       partnersSection: {
//         padding: '60px 0',
//         background: VETRINA_BACKGROUND_LIGHT,
//         borderRadius: '20px', // Added for consistency
//         margin: '60px 0',
//       },
//       // Stats Section ("Numbers Speak")
//       statsSection: {
//         padding: '60px 0',
//         textAlign: 'center',
//       },
//       statCard: {
//         padding: '30px',
//         borderRadius: '15px',
//         background: 'white',
//         boxShadow: '0 10px 20px rgba(0, 0, 0, 0.05)',
//         height: '100%',
//         transition: 'all 0.3s ease',
//         display: 'flex', // Added for centering content
//         flexDirection: 'column', // Added
//         justifyContent: 'center', // Added
//         alignItems: 'center', // Added
//       },
//       statCardHover: {
//         transform: 'translateY(-10px)',
//         boxShadow: `0 15px 30px rgba(184, 82, 158, 0.2)`, // Purple shadow
//       },
//       statNumber: {
//         fontSize: '3rem',
//         fontWeight: '700',
//         marginBottom: '10px',
//         background: `linear-gradient(90deg, ${VETRINA_ORANGE} 0%, ${VETRINA_PURPLE} 100%)`,
//         WebkitBackgroundClip: 'text',
//         backgroundClip: 'text',
//         WebkitTextFillColor: 'transparent',
//       },
//       statTitle: { // Corresponds to .num_for
//         fontSize: '1.2rem',
//         fontWeight: '600', // Original was bold
//         color: VETRINA_TEXT_SECONDARY,
//       },
//       // CTA Section (Subscribe)
//       ctaSection: {
//         padding: '80px 0',
//         textAlign: 'center',
//         background: 'linear-gradient(135deg, #f5f7fa 0%, #e4e8eb 100%)', // Light neutral bg
//         borderRadius: '20px',
//         margin: '60px 0',
//       },
//       ctaTitle: {
//         fontSize: '2.5rem', // Base
//         fontWeight: '700',
//         marginBottom: '20px',
//         color: VETRINA_TEXT_PRIMARY,
//       },
//       ctaText: {
//         fontSize: '1.2rem',
//         lineHeight: '1.6',
//         color: VETRINA_TEXT_SECONDARY,
//         marginBottom: '40px',
//         maxWidth: '700px',
//         margin: '0 auto 40px',
//       },
//       ctaForm: {
//         maxWidth: '500px',
//         margin: '0 auto',
//       },
//       ctaInput: { // Corresponds to .emailbox
//         width: '100%',
//         padding: '15px 20px',
//         borderRadius: '30px',
//         border: '1px solid #ddd',
//         fontSize: '1rem',
//         marginBottom: '20px',
//         outline: 'none',
//         transition: 'all 0.3s ease',
//         // Removed border-bottom only style from .emailbox, using full border
//       },
//       ctaInputFocus: { // To be applied on focus
//         borderColor: VETRINA_PURPLE,
//         boxShadow: `0 0 0 3px rgba(184, 82, 158, 0.2)`,
//       },
//       ctaButton: { // Corresponds to .Subscribe
//         backgroundColor: VETRINA_PURPLE,
//         color: 'white',
//         border: 'none',
//         borderRadius: '30px', // Make consistent with input
//         padding: '15px 30px', // From original
//         // height: '3rem', // from .Subscribe
//         // width: '14rem', // from .Subscribe (padding will control width better)
//         fontSize: '1.1rem', // Adjusted from 26px
//         fontWeight: '600', // original was bold
//         transition: 'all 0.3s ease',
//         cursor: 'pointer',
//         boxShadow: `0 10px 20px rgba(184, 82, 158, 0.3)`,
//         display: 'inline-flex',
//         alignItems: 'center',
//       },
//       ctaButtonHover: { // To be applied on hover
//         background: `linear-gradient(90deg, ${VETRINA_PURPLE} 0%, ${VETRINA_ORANGE} 100%)`,
//         transform: 'translateY(-3px)',
//         boxShadow: `0 15px 30px rgba(184, 82, 158, 0.4)`,
//       },
//       // Back to Top Button
//       backToTopButton: { // from .back-to-top-btn
//         position: 'fixed',
//         bottom: '100px',
//         right: '30px',
//         zIndex: 999,
//         backgroundColor: VETRINA_PURPLE,
//         color: 'white',
//         border: 'none',
//         borderRadius: '50%',
//         width: '50px',
//         height: '50px',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
//         cursor: 'pointer',
//         transition: 'all 0.3s ease',
//       },
//       backToTopButtonHover: { // To be applied on hover
//         backgroundColor: VETRINA_ORANGE,
//         transform: 'translateY(-2px)',
//       },
//       // VetLearn specific list styling
//       vetLearnList: {
//         listStyle: 'none',
//         paddingLeft: 0,
//       },
//       vetLearnListItem: {
//         fontSize: '1rem',
//         lineHeight: '1.7',
//         marginBottom: '15px',
//         paddingLeft: '30px',
//         position: 'relative',
//       },
//       vetLearnListItemBullet: {
//         position: 'absolute',
//         left: '0',
//         top: '5px',
//         color: VETRINA_ORANGE, // Use orange for bullets
//         fontSize: '1.2rem',
//       },
//        // Kaas Logo specific styles from CSS
//       kaasLogoLanding: {
//         height: '50px',
//         width: '100px',
//         // Note: media query for larger size (width: 110px) is hard to do purely inline without JS.
//         // This style will apply for all screen sizes.
//       },
//     };

//     return (
//       <div style={styles.container}> {/* Main container with base font */}
//         <div className='container-fluid px-0'> {/* Changed to container-fluid and px-0 to allow sticky header full width */}
//           {/* Header */}
//           <div className='row pt-3 sticky-top' style={{...styles.header, paddingLeft: '15px', paddingRight: '15px'}}>
// <div className='col-8 col-sm-8 d-flex justify-content-start align-items-center' style={{ flexDirection: 'row' }}>
//               <img src={Kaas} style={styles.kaasLogoLanding} alt='KaaS Logo' />
//             </div>
//             <div className='col-4 col-sm-4 d-flex justify-content-end align-items-center'>
//               <div className='d-flex gap-2 gap-md-3'>
//                 <Link
//                   to="/Log"
//                   role="button"
//                   style={styles.navButton}
//                   onMouseEnter={(e) => Object.assign(e.target.style, styles.navButtonHover)}
//                   onMouseLeave={(e) => Object.assign(e.target.style, styles.navButton)}
//                 >
//                   Sign In
//                 </Link>
//                 <Link
//                   to="/RegisterPage"
//                   role="button"
//                   style={styles.navButton}
//                   onMouseEnter={(e) => Object.assign(e.target.style, styles.navButtonHover)}
//                   onMouseLeave={(e) => Object.assign(e.target.style, styles.navButton)}
//                 >
//                   Sign Up
//                 </Link>
//               </div>
//             </div>
//           </div>

//           {/* Hero Section */}
//           <section style={styles.heroSection}>
//             <div className='container'>
//               <div className='row align-items-center'>
//                 <div className='col-12 col-lg-6' style={styles.heroContent}>
//                   <motion.h1
//                     style={styles.heroTitle}
//                     initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}
//                   >
//                     Up-Skill As You Work
//                   </motion.h1>
//                   <motion.h2
//                     style={styles.heroSubtitle}
//                     initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.2 }}
//                   >
//                     Learning Anywhere, Anytime
//                   </motion.h2>
//                   <motion.p
//                     style={styles.heroDescription}
//                     initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.4 }}
//                   >
//                     Welcome to VetLearn , a personalized learning platform designed
//                     for students and companies alike. Explore courses in
//                     cutting-edge technologies, tailor your learning journey,
//                     and empower employees with expert-led training for skill
//                     development and career growth.
//                   </motion.p>
//                 </div>
//                 <div className='col-12 col-lg-6 mt-5 mt-lg-0 text-center'>
//                   <motion.img
//                     src={bg}
//                     alt='Hero'
//                     style={styles.heroImage}
//                     initial={{ opacity: 0, scale: 0.8 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.8, delay: 0.4 }}
//                     whileHover={{ rotate: 1, scale: 1.03, boxShadow: '0 25px 50px rgba(0,0,0,0.25)' }}
//                   />
//                 </div>
//               </div>
//             </div>
//           </section>

//           {/* What We Do Section */}
//           <section className='container'>
//             <div style={styles.contentSectionGradient}>
//               <div className='row align-items-center'>
//                 <div className='col-12 col-md-4 text-center mb-4 mb-md-0'>
//                   <motion.img
//                     src={wwd} alt='What We Do' style={styles.contentSectionImage}
//                     initial={{ opacity: 0, scale: 0.7 }} whileInView={{ opacity: 1, scale: 1 }} viewport={{ once: true }} transition={{ duration: 0.5 }}
//                   />
//                 </div>
//                 <div className='col-12 col-md-8' style={styles.contentSectionBody}>
//                   <motion.h2 style={styles.contentTitle}
//                     initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5, delay: 0.2 }}>
//                     What We Do
//                   </motion.h2>
//                   <motion.p style={styles.contentText}
//                     initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5, delay: 0.4 }}>
//                     VetLearn  is a prominent one-stop solution for all your learning
//                     needs. The courses have been designed and developed from the
//                     learner perspective. With this software, you may learn the
//                     skills you need to advance professionally and personally.
//                     More than 200 topics are available in the app. Experts from
//                     the real world will assist you in selecting the most
//                     appropriate course for your objectives. Master the skills to
//                     grow professionally and personally with this app.
//                   </motion.p>
//                 </div>
//               </div>
//             </div>
//           </section>

//           {/* Who We Are (VetLearn) Section */}
//           <section className='container my-5 py-5'> {/* Added margin/padding */}
//             <div style={{ textAlign: 'center', marginBottom: '40px' }}>
//                 <h2 style={styles.sectionTitle}>Who We Are</h2>
//                 <div style={styles.sectionTitleUnderline}></div>
//             </div>
//             <div className="row justify-content-center">
//                 <div className="col-md-10 col-lg-8">
//                     <p style={{...styles.contentText, color: VETRINA_TEXT_PRIMARY, textAlign: 'center' }}>
//                         VetLearn is a hybrid learning platform designed to build entrepreneurship, boost productivity, and ensure sustainability in the dairy, poultry and companion animal health industries. Our goal is to equip farmers, professionals, and enthusiasts with the right knowledge, tools, and expert guidance to thrive in animal-based businesses.
//                     </p>
//                     <p style={{...styles.contentText, color: VETRINA_TEXT_PRIMARY, textAlign: 'center' }}>
//                         Our team blends expertise in veterinary sciences, animal nutrition, business development, and technology. Together, we deliver industry-relevant programs led by seasoned professionals and backed by decades of hands-on experience in dairy farming, poultry farming, milk processing, animal health, nutrition, and pet care.
//                     </p>
//                 </div>
//             </div>

//             <div className="row mt-5 justify-content-around">
//                 <div className="col-md-5 mb-4">
//                     <h3 style={{...styles.contentTitle, fontSize: '1.8rem', color: VETRINA_PURPLE, textAlign: 'center' }}>Our Vision</h3>
//                     <p style={{...styles.contentText, color: VETRINA_TEXT_SECONDARY, textAlign: 'center' }}>
//                         To empower livestock and companion animal stakeholders through innovative, expert-led, and technology-driven learning.
//                     </p>
//                 </div>
//                 <div className="col-md-5 mb-4">
//                     <h3 style={{...styles.contentTitle, fontSize: '1.8rem', color: VETRINA_PURPLE, textAlign: 'center' }}>Our Mission</h3>
//                     <p style={{...styles.contentText, color: VETRINA_TEXT_SECONDARY, textAlign: 'center' }}>
//                         "To provide technology-driven learning to make livestock farming simple and profitable, while improving pet health and bringing joy to pet parents."
//                     </p>
//                 </div>
//             </div>

//             <div style={{ textAlign: 'center', marginTop: '50px', marginBottom: '30px' }}>
//                 <h3 style={{...styles.sectionTitle, fontSize: '2rem' }}>Why Choose VetLearn Hub</h3>
//                 <div style={{...styles.sectionTitleUnderline, width: '100px'}}></div>
//             </div>
//             <div className="row justify-content-center">
//                 <div className="col-lg-8">
//                     <ul style={styles.vetLearnList}>
//                         {[
//                             { title: "300+ Courses", text: "From dairy, poultry to other necessary farm management systems to companion animal physiology, nutrition and other important courses, our structured programs cater to beginners, professionals, and large-scale operators." },
//                             { title: "Expert Trainers", text: "Learn directly from industry leaders, veterinarians, nutritionists, technologists, and business experts with hands-on experience in the livestock & companion animal sector." },
//                             { title: "Practical Learning Approach", text: "Experience immersive training with 100% practical, hands-on sessions during offline programs." },
//                             { title: "Complete Business Models", text: "Explore our full roadmaps that guide you from setup to scale-up designed to make livestock farming profitable, productive, and future-ready." },
//                             { title: "Technology-Driven Learning", text: "Our content is delivered using the latest tools ensuring fast, accessible, and effective knowledge transfer." },
//                             { title: "Long-Term Support", text: "Stay connected with the VetLearn team even after course completion for continuous guidance and technical assistance." }
//                         ].map((item, index) => (
//                             <motion.li
//                                 key={index}
//                                 style={styles.vetLearnListItem}
//                                 initial={{ opacity: 0, x: -20 }}
//                                 whileInView={{ opacity: 1, x: 0 }}
//                                 viewport={{ once: true }}
//                                 transition={{ duration: 0.5, delay: index * 0.1 }}
//                             >
//                                 <FaArrowRight style={styles.vetLearnListItemBullet} />
//                                 <strong style={{ color: VETRINA_PURPLE }}>{item.title}: </strong>{item.text}
//                             </motion.li>
//                         ))}
//                     </ul>
//                 </div>
//             </div>
//           </section>

//           {/* Feature Cards Section */}
//           <div className='container my-5'>
//             <div className='row justify-content-center justify-content-md-around pt-4 pt-md-5 g-4'>
//               {[
//                 { icon: analytics, title: "Upgrading knowledge level and skill set", text: "You may upskill yourself and prepare for professional progress by taking advantage of the courses provided.", id: 'feature1' },
//                 { icon: teacher, title: "Industry expert instructors.", text: "The courses are created and taught by experts in the field.", id: 'feature2' },
//                 { icon: period, title: "Learn at your convenience", text: "You can learn at your own speed and in the comfort of your own home.", id: 'feature3' }
//               ].map((card, index) => (
//                 <motion.div
//                   key={card.id}
//                   className='col-10 col-sm-6 col-md-4 col-lg-3 py-2 mb-4' // Bootstrap grid
//                   initial={{ opacity: 0, y: 50 }}
//                   whileInView={{ opacity: 1, y: 0 }}
//                   viewport={{ once: true }}
//                   transition={{ duration: 0.5, delay: index * 0.2 }}
//                 >
//                   <div
//                     style={hoveredFeatureCard === card.id ? { ...styles.featureCard, ...styles.featureCardHover } : styles.featureCard}
//                     onMouseEnter={() => this.setHoveredFeatureCard(card.id)}
//                     onMouseLeave={() => this.setHoveredFeatureCard(null)}
//                   >
//                     <div style={styles.featureCardIconContainer}>
//                       <img className='landinglogo' src={card.icon} alt={card.title} style={styles.featureCardIcon} />
//                     </div>
//                     <p style={styles.featureCardTitle}>{card.title}</p>
//                     <p style={styles.featureCardText}>{card.text}</p>
//                   </div>
//                 </motion.div>
//               ))}
//             </div>
//           </div>

//           {/* Popular Courses Section */}
//           <div className='container' style={styles.popularCoursesSection}>
//             <div className='row mt-3'>
//               <div className='d-flex flex-column flex-md-row justify-content-between align-items-md-center my-3'>
//                 <div>
//                     <h3 style={{ ...styles.sectionTitle, textAlign: 'left', fontSize: '2rem', marginBottom: 0 }}><b>Popular Courses</b></h3>
//                     <div style={{...styles.sectionTitleUnderline, margin: '10px 0 20px 0', width: '60px'}}></div>
//                 </div>
//                 <Link
//                   to='/' // Should be a link to all courses page
//                   style={this.state.isViewAllHovered ? {...styles.viewAllLink, ...styles.viewAllLinkHover} : styles.viewAllLink}
//                   onMouseEnter={() => this.setState({ isViewAllHovered: true })}
//                   onMouseLeave={() => this.setState({ isViewAllHovered: false })}
//                 >
//                   View All
//                 </Link>
//               </div>
//               <div className='row'>
//                 {this.state.popular.slice(0, 3).map((course, idx) => ( // Show 3 popular courses
//                   <div key={idx} className='col-12 col-sm-6 col-lg-4 mb-4'> {/* Added mb-4 for spacing */}
//                     {/* CardsCompo2 is external, assuming it handles its own styling well.
//                         If CardsCompo2 needs theming, it should accept style props or use a context.
//                         Here, we are just passing data.
//                     */}
//                     <CardsCompo2
//                       imageSrc={course.featured_image || vr} // Use featured_image if available
//                       title={course.title}
//                       price={`${course.price}`} // Ensure price is a string
//                       description={course.description}
//                       // Potentially pass hover state or styles if CardsCompo2 supports it
//                     />
//                   </div>
//                 ))}
//               </div>
//             </div>
//           </div>

//           {/* Partners/Logos Section */}
//           <div style={styles.partnersSection}>
//             <div className='container'>
//                 <h2 style={{ ...styles.sectionTitle, color: VETRINA_TEXT_PRIMARY }}>Our Partners</h2>
//                 <div style={styles.sectionTitleUnderline}></div>
//                 <LogosSection />
//             </div>
//           </div>

//           {/* Numbers Speak Section */}

//           {/* CTA Section */}
//           <section style={styles.ctaSection}>
//             <div className='container'>
//               <motion.h2 style={styles.ctaTitle}
//                 initial={{opacity:0, y:20}} whileInView={{opacity:1, y:0}} viewport={{once: true}} transition={{duration:0.5}}>
//                 Are You Ready To Upgrade?
//               </motion.h2>
//               <motion.p style={styles.ctaText}
//                 initial={{opacity:0, y:20}} whileInView={{opacity:1, y:0}} viewport={{once: true}} transition={{duration:0.5, delay:0.2}}>
//                 Join The Journey Towards An Upskilled Future By Reskilling
//                 Yourself With KaaS
//               </motion.p>
//               <motion.form
//                 style={styles.ctaForm}
//                 onSubmit={this.handleSubscribe}
//                 initial={{opacity:0, y:20}} whileInView={{opacity:1, y:0}} viewport={{once: true}} transition={{duration:0.5, delay:0.4}}
//               >
//                 <div className='mb-3'>
//                   <input
//                     type='email'
//                     placeholder='Enter Your Email Address...'
//                     style={this.state.isCtaInputFocused ? {...styles.ctaInput, ...styles.ctaInputFocus} : styles.ctaInput}
//                     value={this.state.email}
//                     onChange={this.handleEmailChange}
//                     onFocus={() => this.setState({ isCtaInputFocused: true })}
//                     onBlur={() => this.setState({ isCtaInputFocused: false })}
//                     required
//                   />
//                 </div>
//                 <button
//                   type='submit'
//                   style={this.state.isCtaButtonHovered ? {...styles.ctaButton, ...styles.ctaButtonHover} : styles.ctaButton}
//                   onMouseEnter={() => this.setState({isCtaButtonHovered: true})}
//                   onMouseLeave={() => this.setState({isCtaButtonHovered: false})}
//                 >
//                   Subscribe <FaEnvelope style={{ marginLeft: '10px' }} />
//                 </button>
//               </motion.form>
//             </div>
//           </section>

//           {/* Back To Top Button */}
//           {this.state.showBackToTop && (
//             <button
//               type='button'
//               style={this.state.isBackToTopHovered ? {...styles.backToTopButton, ...styles.backToTopButtonHover} : styles.backToTopButton}
//               onClick={this.goToTop}
//               onMouseEnter={() => this.setState({ isBackToTopHovered: true })}
//               onMouseLeave={() => this.setState({ isBackToTopHovered: false })}
//               aria-label="Back to top"
//             >
//               <FaArrowUp />
//             </button>
//           )}
//           <Footer /> {/* Assuming Footer component handles its own styling or is very basic */}
//         </div>
//       </div>
//     )
//   }
// }
"use client"

import { useState, useEffect } from "react"
import { motion } from "framer-motion"
import { FaArrowUp, FaEnvelope } from "react-icons/fa"
import axios from "axios"
import Swal from "sweetalert2"

// Import your images
import Kaas from "../Images/Kaas 4.png"
import wwd from "../Images/landing_GroupImage.jpg"
import LogosSection from "../Components/LogosSection"
import Footer from "../Components/Footer"
import bg2 from "../Images/bg2.jpeg"
import image3 from "../Images/image 3.jpg"
import image4 from "../Images/image 4.jpg"
import image5 from "../Images/image 5.jpg"
import image6 from "../Images/image 6.jpg"
import image7 from "../Images/image 7.jpg"
import image8 from "../Images/image 8.jpg"
import centralize from "../Images/CentralizeLearning.jpeg"
import enhanceskill from "../Images/EnhanceSkill.jpeg"
import enabledata from "../Images/EnableData.jpeg"
import YTPATIL from "../Images/ytpatil.jpg"
import YILMR from "../Images/yilmr.jpg"
import VETZONE from "../Images/vetzone logo.jpg"
import VETTALENT from "../Images/vettalent.jpg"
import VETLEARN from "../Images/vetlearn.jpg"
import VETBIZ from "../Images/vetbiz.jpg"
import NARIKISAN from "../Images/narikisan logo.jpg"
import IPWF from "../Images/ipwf.jpg"
import CMPCLUB from "../Images/cmp.jpg"
import YAWYE from "../Images/final yawye logo.jpg"
import build from "../Images/BuildingImage.jpeg"
import LBFTI from "../Images/lbfti.jpeg"
// Define Vetrina Colors
const VETRINA_PURPLE = "#B8529E"
const VETRINA_ORANGE = "#FF6600"
const VETRINA_DARK_PURPLE_ACCENT = "#7D52A0"
const VETRINA_TEXT_PRIMARY = "#333"
const VETRINA_TEXT_SECONDARY = "#666"
const VETRINA_BACKGROUND_LIGHT = "#f9f9f9"
const VETRINA_FOOTER_BG = "#222"

export default function LandingPage() {
  const [popular, setPopular] = useState([])
  const [showBackToTop, setShowBackToTop] = useState(false)
  const [email, setEmail] = useState("")
  const [hoveredFeatureCard, setHoveredFeatureCard] = useState(null)
  const [hoveredCourseCard, setHoveredCourseCard] = useState(null)
  const [hoveredStatCard, setHoveredStatCard] = useState(null)
  const [isViewAllHovered, setIsViewAllHovered] = useState(false)
  const [isCtaInputFocused, setIsCtaInputFocused] = useState(false)
  const [isCtaButtonHovered, setIsCtaButtonHovered] = useState(false)
  const [isBackToTopHovered, setIsBackToTopHovered] = useState(false)
  const [expandedCardId, setExpandedCardId] = useState(null)

  useEffect(() => {
    const url = "https://kaasbackend.vetrinahealthcare.com/"
    axios
      .get(`${url}lms/popular/`)
      .then((response) => {
        setPopular(response.data.popular_courses)
      })
      .catch((error) => {
        console.error("Error fetching popular courses:", error)
      })

    const handleScroll = () => {
      if (window.pageYOffset > 300) {
        setShowBackToTop(true)
      } else {
        setShowBackToTop(false)
      }
    }

    window.addEventListener("scroll", handleScroll)
    return () => window.removeEventListener("scroll", handleScroll)
  }, [])

  const goToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    })
  }

  const handleEmailChange = (e) => {
    setEmail(e.target.value)
  }

  const handleSubscribe = (e) => {
    e.preventDefault()
    if (email) {
      Swal.fire({
        title: "Success!",
        text: "Thank You For Subscribing!",
        icon: "success",
        timer: 2000,
        timerProgressBar: true,
        showConfirmButton: false,
      })
      setEmail("")
    } else {
      Swal.fire({
        title: "Error!",
        text: "Please enter your email address",
        icon: "error",
        timer: 2000,
        showConfirmButton: false,
      })
    }
  }

  const partnersImages = [
    { src: YTPATIL, alt: "YTPATIL" },
    { src: LBFTI, alt: "LBFTI" },
    { src: YILMR, alt: "YILMR" },
    

  ]

  const initiativeImages = [
    { src: VETZONE, alt: "VETZONE" },
    { src: VETBIZ, alt: "VETBIZ" },
    { src: VETTALENT, alt: "VETTALENT" },
    { src: NARIKISAN, alt: "NARIKISAN" },
    { src: IPWF, alt: "IPWF" },
    { src: VETLEARN, alt: "VETLEARN" },
    { src: CMPCLUB, alt: "CMPCLUB" },
    { src: YAWYE, alt: "YAWYE" },
  ]

  const styles = {
    pageWrapper: {
      fontFamily: "'Poppins', sans-serif",
      color: VETRINA_TEXT_PRIMARY,
      margin: 0,
      padding: 0,
      width: "100%",
      overflowX: "hidden",
      
    },
    mainContentWrapper: {
      overflowX: "hidden",
      marginTop:"40px"
    },
    header: {
      padding: "0.2rem 0",
      position: "fixed",
      top: 0,
      backgroundColor: "rgba(255, 255, 255, 0.98)",
      boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
      zIndex: 1000,
      transition: "all 0.3s ease",
      width: "100%",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    headerContainer: {
      width: "100%",
      padding: "0 20px",
      maxWidth: "none",
    },
    logo: {
      height: "50px",
      width: "140px",
    },
    kaasLogoLanding: {
      height: "40px",
      width: "120px",
    },
    vetLearnHeaderText: {
      fontSize: "2.5rem",
      fontWeight: "700",
      background: "linear-gradient(90deg, #a82682, #a92984, #d46b0c, #a82682)",
      WebkitBackgroundClip: "text",
      backgroundClip: "text",
      WebkitTextFillColor: "transparent",
      backgroundSize: "300% 100%",
      animation: "shimmerPublic 5s linear infinite",
      textAlign: "center",
      letterSpacing: "1px",
      textShadow: "0 0 5px rgba(255, 255, 255, 0.3), 0 0 10px rgba(142, 45, 226, 0.2)",
    },
    navButton: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: VETRINA_PURPLE,
      color: "white",
      borderRadius: "20px",
      fontWeight: 600,
      padding: "8px 20px",
      border: "none",
      boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
      textDecoration: "none",
      transition: "all 0.3s ease",
      cursor: "pointer",
    },
    navButtonHover: {
      backgroundColor: VETRINA_ORANGE,
      transform: "translateY(-2px)",
      boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
    },
    heroSection: {
      padding: "60px 20px 40px",
      position: "relative",
      overflow: "hidden",
      width: "100%",
    },
    heroContent: {
      position: "relative",
      zIndex: 2,
    },
    heroTitle: {
      fontSize: "3rem",
      fontWeight: "700",
      marginBottom: "20px",
      background: `linear-gradient(90deg, ${VETRINA_ORANGE} 0%, ${VETRINA_PURPLE} 100%)`,
      WebkitBackgroundClip: "text",
      backgroundClip: "text",
      WebkitTextFillColor: "transparent",
      lineHeight: 1.2,
    },
    heroSubtitle: {
      fontSize: "1.5rem",
      fontWeight: "500",
      marginBottom: "30px",
      color: VETRINA_TEXT_SECONDARY,
    },
    heroDescription: {
      fontSize: "1.1rem",
      lineHeight: "1.6",
      color: VETRINA_TEXT_SECONDARY,
      marginBottom: "30px",
      maxWidth: "600px",
    },
    heroImage: {
      width: "100%",
      maxWidth: "550px",
      height: "auto",
      borderRadius: "20px",
      boxShadow: "0 20px 40px rgba(0, 0, 0, 0.2)",
      transition: "transform 0.5s ease, box-shadow 0.5s ease",
    },
    contentSectionGradient: {
      background: `linear-gradient(120deg, ${VETRINA_ORANGE} 0%, ${VETRINA_PURPLE} 100%)`,
      borderRadius: "20px",
      padding: "40px",
      margin: "60px 20px",
      color: "transparent",
      boxShadow: "0 15px 30px rgba(0, 0, 0, 0.1)",
    },
    contentSectionImage: {
      width: "280px",
      height: "280px",
      objectFit: "cover",
      borderRadius: "50%",
      border: "15px solid white",
      boxShadow: "0 10px 20px rgba(0, 0, 0, 0.2)",
    },
    contentSectionBody: {
      flex: "1",
      minWidth: "300px",
      padding: "0 20px",
    },
    contentTitle: {
      fontSize: "2.5rem",
      fontWeight: "700",
      marginBottom: "20px",
    },
    contentText: {
      fontSize: "1.1rem",
      lineHeight: "1.8",
      marginBottom: "15px",
      width: "100%",
    },
    featureCard: {
      background: "linear-gradient(145deg, #ffffff, #f0f0f0)",
      borderRadius: "15px",
      padding: "20px",
      height: "100%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      textAlign: "center",
      transition: "all 0.3s ease",
      boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
    },
    featureCardHover: {
      transform: "translateY(-10px) scale(1.05)",
      boxShadow: "0 15px 30px rgba(80, 0, 80, 0.2)",
    },
    featureCardIconContainer: {
      width: "100%",
      padding: "20px 15px",
      background: "white",
      borderRadius: "10px",
      boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.05)",
      marginBottom: "15px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    },
    featureCardIcon: {
      height: "10rem",
      width: "auto",
      objectFit: "contain",
      marginBottom: "15px",
    },
    featureCardTitle: {
      fontSize: "1.2rem",
      fontWeight: "bold",
      color: VETRINA_PURPLE,
      margin: "10px 0 5px",
    },
    featureCardText: {
      fontSize: "0.9rem",
      lineHeight: "1.5",
      color: VETRINA_TEXT_SECONDARY,
      flexGrow: 1,
    },
   sectionTitle: {
  fontSize: "2.5rem",
  fontWeight: "700",
  marginBottom: "10px",
  textAlign: "center",
  position: "relative",
  background: `linear-gradient(90deg, ${VETRINA_ORANGE} 0%, ${VETRINA_PURPLE} 100%)`,
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
},

    sectionTitleUnderline: {
      width: "100%",
      height: "4px",
      background: ` ${VETRINA_PURPLE} `,
      
      margin: "0 auto 40px auto",
    },
    popularCoursesSection: {
      padding: "40px 20px",
    },
    viewAllLink: {
      color: VETRINA_PURPLE,
      textDecoration: "none",
      fontWeight: "600",
      padding: "8px 15px",
      borderRadius: "20px",
      transition: "all 0.3s ease",
      border: `1px solid ${VETRINA_PURPLE}`,
    },
    viewAllLinkHover: {
      backgroundColor: VETRINA_PURPLE,
      color: "white",
    },
    partnersSection: {
      padding: "60px 20px",
      background: VETRINA_BACKGROUND_LIGHT,
      borderRadius: "20px",
      margin: "60px 20px",
    },
    ctaSection: {
      padding: "80px 20px",
      textAlign: "center",
      background: "linear-gradient(135deg, #f5f7fa 0%, #e4e8eb 100%)",
      borderRadius: "20px",
      margin: "60px 20px",
    },
    ctaTitle: {
      fontSize: "2.5rem",
      fontWeight: "700",
      marginBottom: "20px",
      color: VETRINA_TEXT_PRIMARY,
    },
    ctaText: {
      fontSize: "1.2rem",
      lineHeight: "1.6",
      color: VETRINA_TEXT_SECONDARY,
      marginBottom: "40px",
      maxWidth: "700px",
      margin: "0 auto 40px",
    },
    ctaForm: {
      maxWidth: "500px",
      margin: "0 auto",
    },
    ctaInput: {
      width: "100%",
      padding: "15px 20px",
      borderRadius: "30px",
      border: "1px solid #ddd",
      fontSize: "1rem",
      marginBottom: "20px",
      outline: "none",
      transition: "all 0.3s ease",
    },
    ctaInputFocus: {
      borderColor: VETRINA_PURPLE,
      boxShadow: `0 0 0 3px rgba(184, 82, 158, 0.2)`,
    },
    ctaButton: {
      backgroundColor: VETRINA_PURPLE,
      color: "black",
      border: "none",
      borderRadius: "30px",
      padding: "15px 30px",
      fontSize: "1.1rem",
      fontWeight: "600",
      transition: "all 0.3s ease",
      cursor: "pointer",
      boxShadow: `0 10px 20px rgba(184, 82, 158, 0.3)`,
      display: "inline-flex",
      alignItems: "center",
    },
    ctaButtonHover: {
      background: `linear-gradient(90deg, ${VETRINA_PURPLE} 0%, ${VETRINA_ORANGE} 100%)`,
      transform: "translateY(-3px)",
      boxShadow: `0 15px 30px rgba(184, 82, 158, 0.4)`,
    },
    backToTopButton: {
      position: "fixed",
      bottom: "100px",
      right: "30px",
      zIndex: 999,
      backgroundColor: VETRINA_PURPLE,
      color: "white",
      border: "none",
      borderRadius: "50%",
      width: "50px",
      height: "50px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
      cursor: "pointer",
      transition: "all 0.3s ease",
    },
    backToTopButtonHover: {
      backgroundColor: VETRINA_ORANGE,
      transform: "translateY(-2px)",
    },
    vetLearnList: {
      listStyle: "none",
      paddingLeft: 0,
    },
    vetLearnListItem: {
      fontSize: "1rem",
      lineHeight: "1.7",
      marginBottom: "15px",
      paddingLeft: "30px",
      position: "relative",
    },
    vetLearnListItemBullet: {
      position: "absolute",
      left: "0",
      top: "5px",
      color: VETRINA_ORANGE,
      fontSize: "1.2rem",
    },
    itemBox: {
      display: "flex",
      alignItems: "flex-start",
      marginBottom: "30px",
    },
    iconImage: {
      width: "60px",
      height: "60px",
      marginRight: "15px",
      marginTop: "5px",
      flexShrink: 0,
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.3)", // ✅ subtle shadow
  borderRadius: "8px"
     
    },
    itemText: {
      fontSize: "16px",
      lineHeight: "1.5",
    },
    itemTitle: {
      fontWeight: "bold",
      color: VETRINA_PURPLE,
    },
    heroImageContainer: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      marginBottom: "2rem",
    },
    buildingCapabilitiesImage: {
      width: "100%",
      maxWidth: "800px",
      height: "auto",
    },
    fullWidthContainer: {
      width: "100%",
      padding: "0 20px",
      maxWidth: "none",
    },
  }

  const items = [
    {
      title: "300+ Courses",
      text: "From dairy, poultry to other necessary farm management systems to companion animal physiology, nutrition and other important courses, our structured programs cater to beginners, professionals, and large-scale operators.",
      icon: image3,
    },
    {
      title: "Expert Trainers",
      text: "Learn directly from industry leaders, veterinarians, nutritionists, technologists, and business experts with hands-on experience in the livestock & companion animal sector.",
      icon: image4,
    },
    {
      title: "Practical Learning Approach",
      text: "Experience immersive training with 100% practical, hands-on sessions during offline programs.",
      icon: image5,
    },
    {
      title: "Complete Business Models",
      text: "Explore our full roadmaps that guide you from setup to scale-up designed to make livestock farming profitable, productive, and future-ready.",
      icon: image6,
    },
    {
      title: "Technology-Driven Learning",
      text: "Our content is delivered using the latest tools ensuring fast, accessible, and effective knowledge transfer.",
      icon: image7,
    },
    {
      title: "Long-Term Support",
      text: "Stay connected with the VetLearn team even after course completion for continuous guidance and technical assistance.",
      icon: image8,
    },
  ]

  // Add CSS keyframes for animation
  const styleSheet = document.createElement("style")
  styleSheet.innerText = `
    @keyframes gradientShift {
      0% { background-position: 0% 50%; }
      50% { background-position: 100% 50%; }
      100% { background-position: 0% 50%; }
    }
  `
  if (!document.head.querySelector("[data-vetlearn-animations]")) {
    styleSheet.setAttribute("data-vetlearn-animations", "true")
    document.head.appendChild(styleSheet)
  }

  return (
    <div style={styles.pageWrapper}>
      {/* Header - Sticky */} 
      <div style={styles.header}>
        <div style={styles.headerContainer}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <div className="col-4 col-sm-4 d-flex justify-content-start align-items-center">
              <img src={Kaas || "/placeholder.svg"} style={styles.kaasLogoLanding} alt="KaaS Logo" />
            </div>
            {/* Center column for VetLearn text - hidden on mobile */}
            <div className="col-4 d-none d-md-flex justify-content-center align-items-center">
              <motion.div
                style={styles.vetLearnHeaderText}
                initial={{ opacity: 0, y: -20 }}
                animate={{
                  opacity: 1,
                  y: 0,
                  backgroundPosition: ["0% 50%", "100% 50%", "0% 50%"],
                }}
                transition={{
                  opacity: { duration: 0.8, ease: "easeOut" },
                  y: { duration: 0.8, ease: "easeOut" },
                  backgroundPosition: {
                    duration: 4,
                    ease: "easeInOut",
                    repeat: Number.POSITIVE_INFINITY,
                  },
                }}
                whileHover={{
                  scale: 1.05,
                  transition: { duration: 0.2 },
                }}
              >
                VetLearn Hub
              </motion.div>
            </div>
            <div className="col-8 col-md-4 d-flex justify-content-end align-items-center">
              <div className="d-flex gap-2 gap-md-3">
                <a
                  href="/Log"
                  role="button"
                  style={styles.navButton}
                  onMouseEnter={(e) => Object.assign(e.target.style, styles.navButtonHover)}
                  onMouseLeave={(e) => Object.assign(e.target.style, styles.navButton)}
                >
                  Sign In
                </a>
                <a
                  href="/log"
                  role="button"
                  style={styles.navButton}
                  onMouseEnter={(e) => Object.assign(e.target.style, styles.navButtonHover)}
                  onMouseLeave={(e) => Object.assign(e.target.style, styles.navButton)}
                >
                  Sign Up
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content Area */}
      <div style={styles.mainContentWrapper}>
        {/* Hero Section */}
        <section style={styles.heroSection}>
          <div style={styles.fullWidthContainer}>
            <div className="row align-items-center">
              <div className="col-12 col-lg-6" style={styles.heroContent}>
                <motion.img
                  src={build || "/placeholder.svg"}
                  alt="Building Capabilities"
                  style={styles.buildingCapabilitiesImage}
                />
              </div>
              <div className="col-12 col-lg-6 mt-5 mt-lg-0 text-center">
                <motion.img
                  src={bg2 || "/placeholder.svg"}
                  alt="Hero"
                  style={styles.heroImage}
                  initial={{ opacity: 0, scale: 0.8 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.8, delay: 0.4 }}
                  whileHover={{
                    rotate: 1,
                    scale: 1.03,
                    boxShadow: "0 25px 50px rgba(0,0,0,0.25)",
                  }}
                />
              </div>
            </div>
          </div>
        </section>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
            width: "100%",
            marginTop: "20px",
            padding: "0 20px",
          }}
        >
          <motion.p
            style={{
              ...styles.heroDescription,
              fontWeight: "bold",
              fontSize: "clamp(2.5rem, 2vw + 1rem, 1.8rem)",
              background: `linear-gradient(90deg, ${VETRINA_ORANGE} 0%, ${VETRINA_PURPLE} 100%)`,
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              backgroundClip: "text",
              color: "transparent",
              margin: 0,
              lineHeight: "1.2",
              maxWidth: "1500px",
            }}
            initial={{ opacity: 0, y: 30, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            transition={{ duration: 1, delay: 0.4 }}
          >
            Driven by Practice. Backed by Research. Taught by Experts.
          </motion.p>
        </div>

        {/* What We Do Section */}
        <section>
          <div style={styles.contentSectionGradient}>
            <div className="row align-items-center">
              <div className="col-12 col-md-4 text-center mb-4 mb-md-0">
                <motion.img
                  src={wwd || "/placeholder.svg"}
                  alt="What We Do"
                  style={styles.contentSectionImage}
                  initial={{ opacity: 0, scale: 0.7 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5 }}
                />
              </div>
              <div className="col-12 col-md-8" style={styles.contentSectionBody}>
                <motion.h2
                  style={{ ...styles.contentTitle, color: "white" }}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: 0.2 }}
                >
                  What is VetLearn
                </motion.h2>
                <motion.p
                  style={{ ...styles.contentText, color: "white" }}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: 0.4 }}
                >
                  "All courses content is designed with a strong focus on practical outcomes, supported by real-world
                  case studies and research conducted by leading veterinary experts." By blending experience with
                  evidence-based knowledge, VetLearn provides a meaningful learning journey that enhances competency,
                  confidence, and on-the-job performance.
                </motion.p>
              </div>
            </div>
          </div>
        </section>

        {/* Who We Are (VetLearn) Section */}
        <section style={{ padding: "40px 20px" }}>
          <div style={{ textAlign: "center", marginBottom: "40px" }}>
            <h2 style={styles.sectionTitle}>Who We Are</h2>
            
            <div style={styles.sectionTitleUnderline}></div>
          </div>
          <div className="row">
            <div className="col-12">
              <p
                style={{
                  ...styles.contentText,
                  color: VETRINA_TEXT_PRIMARY,
                  textAlign: "left",
                }}
              >
                VetLearn is a hybrid learning platform designed to build entrepreneurship, boost productivity, and
                ensure sustainability in the <strong>dairy</strong>, <strong>poultry</strong>, <strong>sheep</strong>
                &amp;<strong>goat</strong>, <strong>swine</strong> and <strong>companion animal health</strong>{" "}
                industries. Our goal is to equip farmers, professionals, and enthusiasts with the right knowledge,
                tools, and expert guidance to thrive in animal-based businesses.
              </p>
              <p
                style={{
                  ...styles.contentText,
                  color: VETRINA_TEXT_PRIMARY,
                  textAlign: "left",
                }}
              >
                Our team blends expertise in veterinary sciences, animal nutrition, business development, and
                technology. Together, we deliver industry-relevant programs led by seasoned professionals and backed by
                decades of hands-on experience in <strong>dairy farming</strong>, <strong>poultry farming</strong>,{" "}
                <strong>sheep</strong>, and <strong>goat farming</strong>, <strong>animal health</strong>,{" "}
                <strong>nutrition</strong>, and <strong>companion animal health</strong>.
              </p>
            </div>
          </div>
          <div className="row mt-5 justify-content-around">
            <div className="col-md-5 mb-4">
              <h3
                style={{
                  ...styles.contentTitle,
                  fontSize: "1.8rem",
                  color: VETRINA_PURPLE,
                  textAlign: "center",
                }}
              >
                Our Vision
              </h3>
              <p
                style={{
                  ...styles.contentText,
                  color: VETRINA_TEXT_SECONDARY,
                  textAlign: "center",
                }}
              >
                "To empower livestock and companion animal stakeholders through innovative, expert-led, and
                technology-driven learning."
              </p>
            </div>
            <div className="col-md-5 mb-4">
              <h3
                style={{
                  ...styles.contentTitle,
                  fontSize: "1.8rem",
                  color: VETRINA_PURPLE,
                  textAlign: "center",
                }}
              >
                Our Mission
              </h3>
              <p
                style={{
                  ...styles.contentText,
                  color: VETRINA_TEXT_SECONDARY,
                  textAlign: "center",
                }}
              >
                "To provide technology-driven learning to make livestock farming simple and profitable, while improving
                pet health and bringing joy to pet parents."
              </p>
            </div>
          </div>
          <div
            style={{
              textAlign: "center",
              marginTop: "50px",
              marginBottom: "30px",
            }}
          >
            <h3 style={{ ...styles.sectionTitle, fontSize: "2rem" }}>Why Choose VetLearn Hub</h3>
            <div style={{ ...styles.sectionTitleUnderline, width: "100px" }}></div>
          </div>
          <div className="row">
            {items.map((item, index) => (
              <div key={index} className="col-md-6">
                <motion.div
                  style={styles.itemBox}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                >
                  <img src={item.icon || "/placeholder.svg"} alt={item.title} style={styles.iconImage} />
                  <div>
                    <div style={styles.itemTitle}>{item.title}</div>
                    <div style={styles.itemText}>{item.text}</div>
                  </div>
                </motion.div>
              </div>
            ))}
          </div>
        </section>

        {/* Feature Cards Section */}
        <div style={{ padding: "40px 20px" }}>
          <div className="row justify-content-center justify-content-md-around pt-4 pt-md-5 g-4">
            {[
              {
                icon: centralize,
                title: "Centralize Learning for Smarter Workforce ",
                text: "VetLearn serves as a unified platform to manage and deliver all training resources, ensuring consistency, accessibility, and alignment with professional goals. It simplifies administration while keeping learning structured and easy to access for every learner.",
                id: "feature1",
              },
              {
                icon: enhanceskill,
                title: "Enhance Skills and Build Competency",
                text: "With interactive modules, practical assessments, and tailored content, VetLearn is designed to boost learner capabilities. It supports continuous upskilling and professional growth, helping individuals and teams perform better in real-world situations.",
                id: "feature2",
              },
              {
                icon: enabledata,
                title: "Enable Data-Driven Learning ",
                text: "VetLearn tracks learning progress, completion rates, and assessment results to offer personalized insights. These analytics empower both learners and administrators to identify strengths, bridge gaps, and align learning with career and business objectives. ",
                id: "feature3",
              },
            ].map((card, index) => (
              <motion.div
                key={card.id}
                className="col-10 col-sm-6 col-md-4 col-lg-3 py-2 mb-4"
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.2 }}
              >
                <div
                  style={
                    hoveredFeatureCard === card.id
                      ? { ...styles.featureCard, ...styles.featureCardHover }
                      : styles.featureCard
                  }
                  onMouseEnter={() => setHoveredFeatureCard(card.id)}
                  onMouseLeave={() => setHoveredFeatureCard(null)}
                >
                  <div style={styles.featureCardIconContainer}>
                    <img
                      className="landinglogo"
                      src={card.icon || "/placeholder.svg"}
                      alt={card.title}
                      style={styles.featureCardIcon}
                    />
                  </div>
                  <p style={styles.featureCardTitle}>{card.title}</p>
                  <p style={styles.featureCardText}>
                    {expandedCardId === card.id
                      ? card.text
                      : card.text.length > 120
                        ? `${card.text.substring(0, 120)}...`
                        : card.text}
                    {card.text.length > 120 && (
                      <span
                        style={{
                          color: "#000",
                          cursor: "pointer",
                          marginLeft: "5px",
                          fontWeight: "500",
                        }}
                        onClick={() => setExpandedCardId(expandedCardId === card.id ? null : card.id)}
                      >
                        {expandedCardId === card.id ? "See less" : "See more"}
                      </span>
                    )}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>

        {/* Partners/Logos Section */}
        <div style={styles.partnersSection}>
          <div
            style={{
              backgroundColor: "#fff",
              borderRadius: "12px",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
              padding: "20px",
            }}
          >
            <LogosSection title="OUR PARTNERS" images={partnersImages} />
            <LogosSection title="OUR INITIATIVE" images={initiativeImages} />
          </div>
        </div>

        {/* CTA Section */}
        <section style={styles.ctaSection}>
          <motion.h2
            style={styles.ctaTitle}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            Are You Ready To Upgrade?
          </motion.h2>
          <motion.p
            style={styles.ctaText}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            Join The Journey Towards An Upskilled Future By Reskilling Yourself With Vetrina
          </motion.p>
          <motion.form
            style={styles.ctaForm}
            onSubmit={handleSubscribe}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.4 }}
          >
            <div className="mb-3">
              <input
                type="email"
                placeholder="Enter Your Email Address..."
                style={isCtaInputFocused ? { ...styles.ctaInput, ...styles.ctaInputFocus } : styles.ctaInput}
                value={email}
                onChange={handleEmailChange}
                onFocus={() => setIsCtaInputFocused(true)}
                onBlur={() => setIsCtaInputFocused(false)}
                required
              />
            </div>
            <button
              type="submit"
              style={isCtaButtonHovered ? { ...styles.ctaButton, ...styles.ctaButtonHover } : styles.ctaButton}
              onMouseEnter={() => setIsCtaButtonHovered(true)}
              onMouseLeave={() => setIsCtaButtonHovered(false)}
            >
              Subscribe <FaEnvelope style={{ marginLeft: "10px" }} />
            </button>
          </motion.form>
        </section>

        {/* Back To Top Button */}
        {showBackToTop && (
          <button
            type="button"
            style={
              isBackToTopHovered
                ? {
                    ...styles.backToTopButton,
                    ...styles.backToTopButtonHover,
                  }
                : styles.backToTopButton
            }
            onClick={goToTop}
            onMouseEnter={() => setIsBackToTopHovered(true)}
            onMouseLeave={() => setIsBackToTopHovered(false)}
            aria-label="Back to top"
          >
            <FaArrowUp />
          </button>
        )}
      </div>
      <Footer />
    </div>
  )
}
